/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedUpdatesIndexRouteImport } from './routes/_authenticated/updates/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedQuotationsIndexRouteImport } from './routes/_authenticated/quotations/index'
import { Route as AuthenticatedInsurancesIndexRouteImport } from './routes/_authenticated/insurances/index'
import { Route as AuthenticatedInboxIndexRouteImport } from './routes/_authenticated/inbox/index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedContactIndexRouteImport } from './routes/_authenticated/contact/index'
import { Route as AuthenticatedClaimsIndexRouteImport } from './routes/_authenticated/claims/index'
import { Route as AuthenticatedAddInsuranceIndexRouteImport } from './routes/_authenticated/add-insurance/index'
import { Route as AuthenticatedUserGuidRouteImport } from './routes/_authenticated/user/$guid'
import { Route as AuthenticatedTasksGuidRouteImport } from './routes/_authenticated/tasks/$guid'
import { Route as AuthenticatedCartCustomersRouteImport } from './routes/_authenticated/cart/customers'
import { Route as AuthenticatedAdministrationEmailSettingsRouteImport } from './routes/_authenticated/administration/email-settings'
import { Route as AuthenticatedAdministrationCompanyDetailsRouteImport } from './routes/_authenticated/administration/company-details'
import { Route as AuthenticatedTasksNewIndexRouteImport } from './routes/_authenticated/tasks/new/index'
import { Route as AuthenticatedCustomersNewIndexRouteImport } from './routes/_authenticated/customers/new/index'
import { Route as AuthenticatedUserGuidEditRouteImport } from './routes/_authenticated/user/$guid.edit'
import { Route as AuthenticatedTasksNewQuotationRouteImport } from './routes/_authenticated/tasks/new/quotation'
import { Route as AuthenticatedTasksNewInsuranceRouteImport } from './routes/_authenticated/tasks/new/insurance'
import { Route as AuthenticatedTasksNewCustomerRouteImport } from './routes/_authenticated/tasks/new/customer'
import { Route as AuthenticatedTasksNewClaimRouteImport } from './routes/_authenticated/tasks/new/claim'
import { Route as AuthenticatedQuotationsGuidLayoutRouteImport } from './routes/_authenticated/quotations/$guid/_layout'
import { Route as AuthenticatedInsurancesGuidLayoutRouteImport } from './routes/_authenticated/insurances/$guid/_layout'
import { Route as AuthenticatedCustomersNewGuidRouteImport } from './routes/_authenticated/customers/new/$guid'
import { Route as AuthenticatedCustomersGuidLayoutRouteImport } from './routes/_authenticated/customers/$guid/_layout'
import { Route as AuthenticatedClaimsNewLayoutRouteImport } from './routes/_authenticated/claims/new/_layout'
import { Route as AuthenticatedClaimsGuidLayoutRouteImport } from './routes/_authenticated/claims/$guid/_layout'
import { Route as AuthenticatedAddInsuranceCustomerSpecialSendRouteImport } from './routes/_authenticated/add-insurance/$customer/special-send'
import { Route as AuthenticatedAddInsuranceCustomerInvoiceSendRouteImport } from './routes/_authenticated/add-insurance/$customer/invoice-send'
import { Route as AuthenticatedAddInsuranceCustomerInsuranceSendRouteImport } from './routes/_authenticated/add-insurance/$customer/insurance-send'
import { Route as AuthenticatedAddInsuranceCustomerLayoutRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout'
import { Route as AuthenticatedQuotationsGuidLayoutIndexRouteImport } from './routes/_authenticated/quotations/$guid/_layout.index'
import { Route as AuthenticatedInsurancesGuidLayoutIndexRouteImport } from './routes/_authenticated/insurances/$guid/_layout.index'
import { Route as AuthenticatedCustomersGuidLayoutIndexRouteImport } from './routes/_authenticated/customers/$guid/_layout.index'
import { Route as AuthenticatedClaimsNewLayoutIndexRouteImport } from './routes/_authenticated/claims/new/_layout.index'
import { Route as AuthenticatedClaimsGuidLayoutIndexRouteImport } from './routes/_authenticated/claims/$guid/_layout.index'
import { Route as AuthenticatedAddInsuranceCustomerLayoutIndexRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout.index'
import { Route as AuthenticatedQuotationsGuidLayoutTasksRouteImport } from './routes/_authenticated/quotations/$guid/_layout.tasks'
import { Route as AuthenticatedQuotationsGuidLayoutPremiumDataRouteImport } from './routes/_authenticated/quotations/$guid/_layout.premium-data'
import { Route as AuthenticatedQuotationsGuidLayoutNotesRouteImport } from './routes/_authenticated/quotations/$guid/_layout.notes'
import { Route as AuthenticatedQuotationsGuidLayoutActivitiesRouteImport } from './routes/_authenticated/quotations/$guid/_layout.activities'
import { Route as AuthenticatedInsurancesGuidLayoutTasksRouteImport } from './routes/_authenticated/insurances/$guid/_layout.tasks'
import { Route as AuthenticatedInsurancesGuidLayoutNotesRouteImport } from './routes/_authenticated/insurances/$guid/_layout.notes'
import { Route as AuthenticatedInsurancesGuidLayoutDocumentsRouteImport } from './routes/_authenticated/insurances/$guid/_layout.documents'
import { Route as AuthenticatedInsurancesGuidLayoutClaimsRouteImport } from './routes/_authenticated/insurances/$guid/_layout.claims'
import { Route as AuthenticatedInsurancesGuidLayoutActivitiesRouteImport } from './routes/_authenticated/insurances/$guid/_layout.activities'
import { Route as AuthenticatedCustomersGuidEditSuccessRouteImport } from './routes/_authenticated/customers/$guid/edit/success'
import { Route as AuthenticatedCustomersGuidEditLayoutRouteImport } from './routes/_authenticated/customers/$guid/edit/_layout'
import { Route as AuthenticatedCustomersGuidLayoutTasksRouteImport } from './routes/_authenticated/customers/$guid/_layout.tasks'
import { Route as AuthenticatedCustomersGuidLayoutQuotationsRouteImport } from './routes/_authenticated/customers/$guid/_layout.quotations'
import { Route as AuthenticatedCustomersGuidLayoutNotesRouteImport } from './routes/_authenticated/customers/$guid/_layout.notes'
import { Route as AuthenticatedCustomersGuidLayoutInvoicesRouteImport } from './routes/_authenticated/customers/$guid/_layout.invoices'
import { Route as AuthenticatedCustomersGuidLayoutInsurancesRouteImport } from './routes/_authenticated/customers/$guid/_layout.insurances'
import { Route as AuthenticatedCustomersGuidLayoutClaimsRouteImport } from './routes/_authenticated/customers/$guid/_layout.claims'
import { Route as AuthenticatedCustomersGuidLayoutActivitiesRouteImport } from './routes/_authenticated/customers/$guid/_layout.activities'
import { Route as AuthenticatedClaimsGuidLayoutTasksRouteImport } from './routes/_authenticated/claims/$guid/_layout.tasks'
import { Route as AuthenticatedClaimsGuidLayoutNotesRouteImport } from './routes/_authenticated/claims/$guid/_layout.notes'
import { Route as AuthenticatedClaimsGuidLayoutDocumentsRouteImport } from './routes/_authenticated/claims/$guid/_layout.documents'
import { Route as AuthenticatedClaimsGuidLayoutDetailsRouteImport } from './routes/_authenticated/claims/$guid/_layout.details'
import { Route as AuthenticatedClaimsGuidLayoutActivitiesRouteImport } from './routes/_authenticated/claims/$guid/_layout.activities'
import { Route as AuthenticatedCartNewCustomerLayoutRouteImport } from './routes/_authenticated/cart/new/$customer/_layout'
import { Route as AuthenticatedAddInsuranceCustomerLayoutObRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout.ob'
import { Route as AuthenticatedCustomersGuidEditLayoutIndexRouteImport } from './routes/_authenticated/customers/$guid/edit/_layout.index'
import { Route as AuthenticatedClaimsNewLayoutCustomerIndexRouteImport } from './routes/_authenticated/claims/new/_layout.$customer/index'
import { Route as AuthenticatedEditInsuranceCustomerCartCartSummaryRouteImport } from './routes/_authenticated/edit-insurance/$customer.cart.$cart/summary'
import { Route as AuthenticatedEditInsuranceCustomerCartCartSuccessRouteImport } from './routes/_authenticated/edit-insurance/$customer.cart.$cart/success'
import { Route as AuthenticatedEditInsuranceCustomerCartCartLayoutRouteImport } from './routes/_authenticated/edit-insurance/$customer.cart.$cart/_layout'
import { Route as AuthenticatedCustomersGuidEditLayoutPersonalDataRouteImport } from './routes/_authenticated/customers/$guid/edit/_layout.personal-data'
import { Route as AuthenticatedCustomersGuidEditLayoutPaymentRouteImport } from './routes/_authenticated/customers/$guid/edit/_layout.payment'
import { Route as AuthenticatedCustomersGuidEditLayoutContactRouteImport } from './routes/_authenticated/customers/$guid/edit/_layout.contact'
import { Route as AuthenticatedCustomersGuidEditLayoutAddressRouteImport } from './routes/_authenticated/customers/$guid/edit/_layout.address'
import { Route as AuthenticatedClaimsNewLayoutCustomerSuccessRouteImport } from './routes/_authenticated/claims/new/_layout.$customer/success'
import { Route as AuthenticatedClaimsNewLayoutCustomerLinkSendRouteImport } from './routes/_authenticated/claims/new/_layout.$customer/link-send'
import { Route as AuthenticatedClaimsNewLayoutCustomerExternalSystemRouteImport } from './routes/_authenticated/claims/new/_layout.$customer/external-system'
import { Route as AuthenticatedClaimsNewLayoutCustomerInsuranceRouteImport } from './routes/_authenticated/claims/new/_layout.$customer/$insurance'
import { Route as AuthenticatedCartNewCustomerLayoutProductsRouteImport } from './routes/_authenticated/cart/new/$customer/_layout.products'
import { Route as AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRouteImport } from './routes/_authenticated/edit-insurance/$customer.cart.$cart/_layout.index'
import { Route as AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRouteImport } from './routes/_authenticated/edit-insurance/$customer.cart.$cart/_layout.compositions'
import { Route as AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRouteImport } from './routes/_authenticated/cart/new/$customer/_layout.(object-code)/_layout.ob'
import { Route as AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRouteImport } from './routes/_authenticated/cancel-insurance/$customer.cart.$cart.insurance.$insurance/success'
import { Route as AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteImport } from './routes/_authenticated/cancel-insurance/$customer.cart.$cart.insurance.$insurance/_layout'
import { Route as AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout-cart.cart/$cart/_layout-cart.summary'
import { Route as AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout-cart.cart/$cart/_layout-cart.special'
import { Route as AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRouteImport } from './routes/_authenticated/cancel-insurance/$customer.cart.$cart.insurance.$insurance/_layout.index'
import { Route as AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRouteImport } from './routes/_authenticated/cancel-insurance/$customer.cart.$cart.insurance.$insurance/_layout.summary'
import { Route as AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout-cart.cart/$cart/product/$product/_layout-cart'
import { Route as AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout-cart.cart/$cart/product/$product/_layout-cart.index'
import { Route as AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRouteImport } from './routes/_authenticated/add-insurance/$customer/_layout-cart.cart/$cart/product/$product/_layout-cart.compositions'

const AuthenticatedQuotationsGuidRouteImport = createFileRoute(
  '/_authenticated/quotations/$guid',
)()
const AuthenticatedInsurancesGuidRouteImport = createFileRoute(
  '/_authenticated/insurances/$guid',
)()
const AuthenticatedCustomersGuidRouteImport = createFileRoute(
  '/_authenticated/customers/$guid',
)()
const AuthenticatedClaimsNewRouteImport = createFileRoute(
  '/_authenticated/claims/new',
)()
const AuthenticatedClaimsGuidRouteImport = createFileRoute(
  '/_authenticated/claims/$guid',
)()
const AuthenticatedAddInsuranceCustomerRouteImport = createFileRoute(
  '/_authenticated/add-insurance/$customer',
)()
const AuthenticatedCustomersGuidEditRouteImport = createFileRoute(
  '/_authenticated/customers/$guid/edit',
)()
const AuthenticatedCartNewCustomerRouteImport = createFileRoute(
  '/_authenticated/cart/new/$customer',
)()
const AuthenticatedEditInsuranceCustomerCartCartRouteImport = createFileRoute(
  '/_authenticated/edit-insurance/$customer/cart/$cart',
)()
const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteImport =
  createFileRoute(
    '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance',
  )()
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteImport =
  createFileRoute(
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product',
  )()

const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuotationsGuidRoute =
  AuthenticatedQuotationsGuidRouteImport.update({
    id: '/quotations/$guid',
    path: '/quotations/$guid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInsurancesGuidRoute =
  AuthenticatedInsurancesGuidRouteImport.update({
    id: '/insurances/$guid',
    path: '/insurances/$guid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersGuidRoute =
  AuthenticatedCustomersGuidRouteImport.update({
    id: '/customers/$guid',
    path: '/customers/$guid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClaimsNewRoute = AuthenticatedClaimsNewRouteImport.update({
  id: '/claims/new',
  path: '/claims/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClaimsGuidRoute = AuthenticatedClaimsGuidRouteImport.update({
  id: '/claims/$guid',
  path: '/claims/$guid',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAddInsuranceCustomerRoute =
  AuthenticatedAddInsuranceCustomerRouteImport.update({
    id: '/add-insurance/$customer',
    path: '/add-insurance/$customer',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUpdatesIndexRoute =
  AuthenticatedUpdatesIndexRouteImport.update({
    id: '/updates/',
    path: '/updates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuotationsIndexRoute =
  AuthenticatedQuotationsIndexRouteImport.update({
    id: '/quotations/',
    path: '/quotations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInsurancesIndexRoute =
  AuthenticatedInsurancesIndexRouteImport.update({
    id: '/insurances/',
    path: '/insurances/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInboxIndexRoute = AuthenticatedInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactIndexRoute =
  AuthenticatedContactIndexRouteImport.update({
    id: '/contact/',
    path: '/contact/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClaimsIndexRoute =
  AuthenticatedClaimsIndexRouteImport.update({
    id: '/claims/',
    path: '/claims/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAddInsuranceIndexRoute =
  AuthenticatedAddInsuranceIndexRouteImport.update({
    id: '/add-insurance/',
    path: '/add-insurance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserGuidRoute = AuthenticatedUserGuidRouteImport.update({
  id: '/user/$guid',
  path: '/user/$guid',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksGuidRoute = AuthenticatedTasksGuidRouteImport.update({
  id: '/tasks/$guid',
  path: '/tasks/$guid',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCartCustomersRoute =
  AuthenticatedCartCustomersRouteImport.update({
    id: '/cart/customers',
    path: '/cart/customers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdministrationEmailSettingsRoute =
  AuthenticatedAdministrationEmailSettingsRouteImport.update({
    id: '/administration/email-settings',
    path: '/administration/email-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdministrationCompanyDetailsRoute =
  AuthenticatedAdministrationCompanyDetailsRouteImport.update({
    id: '/administration/company-details',
    path: '/administration/company-details',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersGuidEditRoute =
  AuthenticatedCustomersGuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedCustomersGuidRoute,
  } as any)
const AuthenticatedCartNewCustomerRoute =
  AuthenticatedCartNewCustomerRouteImport.update({
    id: '/cart/new/$customer',
    path: '/cart/new/$customer',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewIndexRoute =
  AuthenticatedTasksNewIndexRouteImport.update({
    id: '/tasks/new/',
    path: '/tasks/new/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersNewIndexRoute =
  AuthenticatedCustomersNewIndexRouteImport.update({
    id: '/customers/new/',
    path: '/customers/new/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserGuidEditRoute =
  AuthenticatedUserGuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedUserGuidRoute,
  } as any)
const AuthenticatedTasksNewQuotationRoute =
  AuthenticatedTasksNewQuotationRouteImport.update({
    id: '/tasks/new/quotation',
    path: '/tasks/new/quotation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewInsuranceRoute =
  AuthenticatedTasksNewInsuranceRouteImport.update({
    id: '/tasks/new/insurance',
    path: '/tasks/new/insurance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewCustomerRoute =
  AuthenticatedTasksNewCustomerRouteImport.update({
    id: '/tasks/new/customer',
    path: '/tasks/new/customer',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewClaimRoute =
  AuthenticatedTasksNewClaimRouteImport.update({
    id: '/tasks/new/claim',
    path: '/tasks/new/claim',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuotationsGuidLayoutRoute =
  AuthenticatedQuotationsGuidLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedQuotationsGuidRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutRoute =
  AuthenticatedInsurancesGuidLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedInsurancesGuidRoute,
  } as any)
const AuthenticatedCustomersNewGuidRoute =
  AuthenticatedCustomersNewGuidRouteImport.update({
    id: '/customers/new/$guid',
    path: '/customers/new/$guid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutRoute =
  AuthenticatedCustomersGuidLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedCustomersGuidRoute,
  } as any)
const AuthenticatedClaimsNewLayoutRoute =
  AuthenticatedClaimsNewLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedClaimsNewRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutRoute =
  AuthenticatedClaimsGuidLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedClaimsGuidRoute,
  } as any)
const AuthenticatedAddInsuranceCustomerSpecialSendRoute =
  AuthenticatedAddInsuranceCustomerSpecialSendRouteImport.update({
    id: '/special-send',
    path: '/special-send',
    getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
  } as any)
const AuthenticatedAddInsuranceCustomerInvoiceSendRoute =
  AuthenticatedAddInsuranceCustomerInvoiceSendRouteImport.update({
    id: '/invoice-send',
    path: '/invoice-send',
    getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
  } as any)
const AuthenticatedAddInsuranceCustomerInsuranceSendRoute =
  AuthenticatedAddInsuranceCustomerInsuranceSendRouteImport.update({
    id: '/insurance-send',
    path: '/insurance-send',
    getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
  } as any)
const AuthenticatedAddInsuranceCustomerLayoutRoute =
  AuthenticatedAddInsuranceCustomerLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
  } as any)
const AuthenticatedEditInsuranceCustomerCartCartRoute =
  AuthenticatedEditInsuranceCustomerCartCartRouteImport.update({
    id: '/edit-insurance/$customer/cart/$cart',
    path: '/edit-insurance/$customer/cart/$cart',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuotationsGuidLayoutIndexRoute =
  AuthenticatedQuotationsGuidLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedQuotationsGuidLayoutRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutIndexRoute =
  AuthenticatedInsurancesGuidLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInsurancesGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutIndexRoute =
  AuthenticatedCustomersGuidLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedClaimsNewLayoutIndexRoute =
  AuthenticatedClaimsNewLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClaimsNewLayoutRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutIndexRoute =
  AuthenticatedClaimsGuidLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClaimsGuidLayoutRoute,
  } as any)
const AuthenticatedAddInsuranceCustomerLayoutIndexRoute =
  AuthenticatedAddInsuranceCustomerLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAddInsuranceCustomerLayoutRoute,
  } as any)
const AuthenticatedQuotationsGuidLayoutTasksRoute =
  AuthenticatedQuotationsGuidLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedQuotationsGuidLayoutRoute,
  } as any)
const AuthenticatedQuotationsGuidLayoutPremiumDataRoute =
  AuthenticatedQuotationsGuidLayoutPremiumDataRouteImport.update({
    id: '/premium-data',
    path: '/premium-data',
    getParentRoute: () => AuthenticatedQuotationsGuidLayoutRoute,
  } as any)
const AuthenticatedQuotationsGuidLayoutNotesRoute =
  AuthenticatedQuotationsGuidLayoutNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthenticatedQuotationsGuidLayoutRoute,
  } as any)
const AuthenticatedQuotationsGuidLayoutActivitiesRoute =
  AuthenticatedQuotationsGuidLayoutActivitiesRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => AuthenticatedQuotationsGuidLayoutRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutTasksRoute =
  AuthenticatedInsurancesGuidLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedInsurancesGuidLayoutRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutNotesRoute =
  AuthenticatedInsurancesGuidLayoutNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthenticatedInsurancesGuidLayoutRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutDocumentsRoute =
  AuthenticatedInsurancesGuidLayoutDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedInsurancesGuidLayoutRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutClaimsRoute =
  AuthenticatedInsurancesGuidLayoutClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => AuthenticatedInsurancesGuidLayoutRoute,
  } as any)
const AuthenticatedInsurancesGuidLayoutActivitiesRoute =
  AuthenticatedInsurancesGuidLayoutActivitiesRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => AuthenticatedInsurancesGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidEditSuccessRoute =
  AuthenticatedCustomersGuidEditSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedCustomersGuidEditRoute,
  } as any)
const AuthenticatedCustomersGuidEditLayoutRoute =
  AuthenticatedCustomersGuidEditLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedCustomersGuidEditRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutTasksRoute =
  AuthenticatedCustomersGuidLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutQuotationsRoute =
  AuthenticatedCustomersGuidLayoutQuotationsRouteImport.update({
    id: '/quotations',
    path: '/quotations',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutNotesRoute =
  AuthenticatedCustomersGuidLayoutNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutInvoicesRoute =
  AuthenticatedCustomersGuidLayoutInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutInsurancesRoute =
  AuthenticatedCustomersGuidLayoutInsurancesRouteImport.update({
    id: '/insurances',
    path: '/insurances',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutClaimsRoute =
  AuthenticatedCustomersGuidLayoutClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidLayoutActivitiesRoute =
  AuthenticatedCustomersGuidLayoutActivitiesRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => AuthenticatedCustomersGuidLayoutRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutTasksRoute =
  AuthenticatedClaimsGuidLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedClaimsGuidLayoutRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutNotesRoute =
  AuthenticatedClaimsGuidLayoutNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthenticatedClaimsGuidLayoutRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutDocumentsRoute =
  AuthenticatedClaimsGuidLayoutDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedClaimsGuidLayoutRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutDetailsRoute =
  AuthenticatedClaimsGuidLayoutDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedClaimsGuidLayoutRoute,
  } as any)
const AuthenticatedClaimsGuidLayoutActivitiesRoute =
  AuthenticatedClaimsGuidLayoutActivitiesRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => AuthenticatedClaimsGuidLayoutRoute,
  } as any)
const AuthenticatedCartNewCustomerLayoutRoute =
  AuthenticatedCartNewCustomerLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedCartNewCustomerRoute,
  } as any)
const AuthenticatedAddInsuranceCustomerLayoutObRoute =
  AuthenticatedAddInsuranceCustomerLayoutObRouteImport.update({
    id: '/ob',
    path: '/ob',
    getParentRoute: () => AuthenticatedAddInsuranceCustomerLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidEditLayoutIndexRoute =
  AuthenticatedCustomersGuidEditLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomersGuidEditLayoutRoute,
  } as any)
const AuthenticatedClaimsNewLayoutCustomerIndexRoute =
  AuthenticatedClaimsNewLayoutCustomerIndexRouteImport.update({
    id: '/$customer/',
    path: '/$customer/',
    getParentRoute: () => AuthenticatedClaimsNewLayoutRoute,
  } as any)
const AuthenticatedEditInsuranceCustomerCartCartSummaryRoute =
  AuthenticatedEditInsuranceCustomerCartCartSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedEditInsuranceCustomerCartCartRoute,
  } as any)
const AuthenticatedEditInsuranceCustomerCartCartSuccessRoute =
  AuthenticatedEditInsuranceCustomerCartCartSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedEditInsuranceCustomerCartCartRoute,
  } as any)
const AuthenticatedEditInsuranceCustomerCartCartLayoutRoute =
  AuthenticatedEditInsuranceCustomerCartCartLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedEditInsuranceCustomerCartCartRoute,
  } as any)
const AuthenticatedCustomersGuidEditLayoutPersonalDataRoute =
  AuthenticatedCustomersGuidEditLayoutPersonalDataRouteImport.update({
    id: '/personal-data',
    path: '/personal-data',
    getParentRoute: () => AuthenticatedCustomersGuidEditLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidEditLayoutPaymentRoute =
  AuthenticatedCustomersGuidEditLayoutPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => AuthenticatedCustomersGuidEditLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidEditLayoutContactRoute =
  AuthenticatedCustomersGuidEditLayoutContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => AuthenticatedCustomersGuidEditLayoutRoute,
  } as any)
const AuthenticatedCustomersGuidEditLayoutAddressRoute =
  AuthenticatedCustomersGuidEditLayoutAddressRouteImport.update({
    id: '/address',
    path: '/address',
    getParentRoute: () => AuthenticatedCustomersGuidEditLayoutRoute,
  } as any)
const AuthenticatedClaimsNewLayoutCustomerSuccessRoute =
  AuthenticatedClaimsNewLayoutCustomerSuccessRouteImport.update({
    id: '/$customer/success',
    path: '/$customer/success',
    getParentRoute: () => AuthenticatedClaimsNewLayoutRoute,
  } as any)
const AuthenticatedClaimsNewLayoutCustomerLinkSendRoute =
  AuthenticatedClaimsNewLayoutCustomerLinkSendRouteImport.update({
    id: '/$customer/link-send',
    path: '/$customer/link-send',
    getParentRoute: () => AuthenticatedClaimsNewLayoutRoute,
  } as any)
const AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute =
  AuthenticatedClaimsNewLayoutCustomerExternalSystemRouteImport.update({
    id: '/$customer/external-system',
    path: '/$customer/external-system',
    getParentRoute: () => AuthenticatedClaimsNewLayoutRoute,
  } as any)
const AuthenticatedClaimsNewLayoutCustomerInsuranceRoute =
  AuthenticatedClaimsNewLayoutCustomerInsuranceRouteImport.update({
    id: '/$customer/$insurance',
    path: '/$customer/$insurance',
    getParentRoute: () => AuthenticatedClaimsNewLayoutRoute,
  } as any)
const AuthenticatedCartNewCustomerLayoutProductsRoute =
  AuthenticatedCartNewCustomerLayoutProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedCartNewCustomerLayoutRoute,
  } as any)
const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteImport.update(
    {
      id: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance',
      path: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute =
  AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEditInsuranceCustomerCartCartLayoutRoute,
  } as any)
const AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute =
  AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRouteImport.update(
    {
      id: '/compositions',
      path: '/compositions',
      getParentRoute: () =>
        AuthenticatedEditInsuranceCustomerCartCartLayoutRoute,
    } as any,
  )
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRoute =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteImport.update(
    {
      id: '/_layout-cart/cart/$cart/product/$product',
      path: '/cart/$cart/product/$product',
      getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
    } as any,
  )
const AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute =
  AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRouteImport.update({
    id: '/(object-code)/_layout/ob',
    path: '/ob',
    getParentRoute: () => AuthenticatedCartNewCustomerLayoutRoute,
  } as any)
const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRouteImport.update(
    {
      id: '/success',
      path: '/success',
      getParentRoute: () =>
        AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute,
    } as any,
  )
const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute,
    } as any,
  )
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRouteImport.update(
    {
      id: '/_layout-cart/cart/$cart/_layout-cart/summary',
      path: '/cart/$cart/summary',
      getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
    } as any,
  )
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRouteImport.update(
    {
      id: '/_layout-cart/cart/$cart/_layout-cart/special',
      path: '/cart/$cart/special',
      getParentRoute: () => AuthenticatedAddInsuranceCustomerRoute,
    } as any,
  )
const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute,
    } as any,
  )
const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRouteImport.update(
    {
      id: '/summary',
      path: '/summary',
      getParentRoute: () =>
        AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute,
    } as any,
  )
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteImport.update(
    {
      id: '/_layout-cart',
      getParentRoute: () =>
        AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRoute,
    } as any,
  )
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute,
    } as any,
  )
const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRouteImport.update(
    {
      id: '/compositions',
      path: '/compositions',
      getParentRoute: () =>
        AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/administration/company-details': typeof AuthenticatedAdministrationCompanyDetailsRoute
  '/administration/email-settings': typeof AuthenticatedAdministrationEmailSettingsRoute
  '/cart/customers': typeof AuthenticatedCartCustomersRoute
  '/tasks/$guid': typeof AuthenticatedTasksGuidRoute
  '/user/$guid': typeof AuthenticatedUserGuidRouteWithChildren
  '/add-insurance': typeof AuthenticatedAddInsuranceIndexRoute
  '/claims': typeof AuthenticatedClaimsIndexRoute
  '/contact': typeof AuthenticatedContactIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/inbox': typeof AuthenticatedInboxIndexRoute
  '/insurances': typeof AuthenticatedInsurancesIndexRoute
  '/quotations': typeof AuthenticatedQuotationsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/updates': typeof AuthenticatedUpdatesIndexRoute
  '/add-insurance/$customer': typeof AuthenticatedAddInsuranceCustomerLayoutRouteWithChildren
  '/add-insurance/$customer/insurance-send': typeof AuthenticatedAddInsuranceCustomerInsuranceSendRoute
  '/add-insurance/$customer/invoice-send': typeof AuthenticatedAddInsuranceCustomerInvoiceSendRoute
  '/add-insurance/$customer/special-send': typeof AuthenticatedAddInsuranceCustomerSpecialSendRoute
  '/claims/$guid': typeof AuthenticatedClaimsGuidLayoutRouteWithChildren
  '/claims/new': typeof AuthenticatedClaimsNewLayoutRouteWithChildren
  '/customers/$guid': typeof AuthenticatedCustomersGuidLayoutRouteWithChildren
  '/customers/new/$guid': typeof AuthenticatedCustomersNewGuidRoute
  '/insurances/$guid': typeof AuthenticatedInsurancesGuidLayoutRouteWithChildren
  '/quotations/$guid': typeof AuthenticatedQuotationsGuidLayoutRouteWithChildren
  '/tasks/new/claim': typeof AuthenticatedTasksNewClaimRoute
  '/tasks/new/customer': typeof AuthenticatedTasksNewCustomerRoute
  '/tasks/new/insurance': typeof AuthenticatedTasksNewInsuranceRoute
  '/tasks/new/quotation': typeof AuthenticatedTasksNewQuotationRoute
  '/user/$guid/edit': typeof AuthenticatedUserGuidEditRoute
  '/customers/new': typeof AuthenticatedCustomersNewIndexRoute
  '/tasks/new': typeof AuthenticatedTasksNewIndexRoute
  '/add-insurance/$customer/ob': typeof AuthenticatedAddInsuranceCustomerLayoutObRoute
  '/cart/new/$customer': typeof AuthenticatedCartNewCustomerLayoutRouteWithChildren
  '/claims/$guid/activities': typeof AuthenticatedClaimsGuidLayoutActivitiesRoute
  '/claims/$guid/details': typeof AuthenticatedClaimsGuidLayoutDetailsRoute
  '/claims/$guid/documents': typeof AuthenticatedClaimsGuidLayoutDocumentsRoute
  '/claims/$guid/notes': typeof AuthenticatedClaimsGuidLayoutNotesRoute
  '/claims/$guid/tasks': typeof AuthenticatedClaimsGuidLayoutTasksRoute
  '/customers/$guid/activities': typeof AuthenticatedCustomersGuidLayoutActivitiesRoute
  '/customers/$guid/claims': typeof AuthenticatedCustomersGuidLayoutClaimsRoute
  '/customers/$guid/insurances': typeof AuthenticatedCustomersGuidLayoutInsurancesRoute
  '/customers/$guid/invoices': typeof AuthenticatedCustomersGuidLayoutInvoicesRoute
  '/customers/$guid/notes': typeof AuthenticatedCustomersGuidLayoutNotesRoute
  '/customers/$guid/quotations': typeof AuthenticatedCustomersGuidLayoutQuotationsRoute
  '/customers/$guid/tasks': typeof AuthenticatedCustomersGuidLayoutTasksRoute
  '/customers/$guid/edit': typeof AuthenticatedCustomersGuidEditLayoutRouteWithChildren
  '/customers/$guid/edit/success': typeof AuthenticatedCustomersGuidEditSuccessRoute
  '/insurances/$guid/activities': typeof AuthenticatedInsurancesGuidLayoutActivitiesRoute
  '/insurances/$guid/claims': typeof AuthenticatedInsurancesGuidLayoutClaimsRoute
  '/insurances/$guid/documents': typeof AuthenticatedInsurancesGuidLayoutDocumentsRoute
  '/insurances/$guid/notes': typeof AuthenticatedInsurancesGuidLayoutNotesRoute
  '/insurances/$guid/tasks': typeof AuthenticatedInsurancesGuidLayoutTasksRoute
  '/quotations/$guid/activities': typeof AuthenticatedQuotationsGuidLayoutActivitiesRoute
  '/quotations/$guid/notes': typeof AuthenticatedQuotationsGuidLayoutNotesRoute
  '/quotations/$guid/premium-data': typeof AuthenticatedQuotationsGuidLayoutPremiumDataRoute
  '/quotations/$guid/tasks': typeof AuthenticatedQuotationsGuidLayoutTasksRoute
  '/add-insurance/$customer/': typeof AuthenticatedAddInsuranceCustomerLayoutIndexRoute
  '/claims/$guid/': typeof AuthenticatedClaimsGuidLayoutIndexRoute
  '/claims/new/': typeof AuthenticatedClaimsNewLayoutIndexRoute
  '/customers/$guid/': typeof AuthenticatedCustomersGuidLayoutIndexRoute
  '/insurances/$guid/': typeof AuthenticatedInsurancesGuidLayoutIndexRoute
  '/quotations/$guid/': typeof AuthenticatedQuotationsGuidLayoutIndexRoute
  '/cart/new/$customer/products': typeof AuthenticatedCartNewCustomerLayoutProductsRoute
  '/claims/new/$customer/$insurance': typeof AuthenticatedClaimsNewLayoutCustomerInsuranceRoute
  '/claims/new/$customer/external-system': typeof AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute
  '/claims/new/$customer/link-send': typeof AuthenticatedClaimsNewLayoutCustomerLinkSendRoute
  '/claims/new/$customer/success': typeof AuthenticatedClaimsNewLayoutCustomerSuccessRoute
  '/customers/$guid/edit/address': typeof AuthenticatedCustomersGuidEditLayoutAddressRoute
  '/customers/$guid/edit/contact': typeof AuthenticatedCustomersGuidEditLayoutContactRoute
  '/customers/$guid/edit/payment': typeof AuthenticatedCustomersGuidEditLayoutPaymentRoute
  '/customers/$guid/edit/personal-data': typeof AuthenticatedCustomersGuidEditLayoutPersonalDataRoute
  '/edit-insurance/$customer/cart/$cart': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutRouteWithChildren
  '/edit-insurance/$customer/cart/$cart/success': typeof AuthenticatedEditInsuranceCustomerCartCartSuccessRoute
  '/edit-insurance/$customer/cart/$cart/summary': typeof AuthenticatedEditInsuranceCustomerCartCartSummaryRoute
  '/claims/new/$customer': typeof AuthenticatedClaimsNewLayoutCustomerIndexRoute
  '/customers/$guid/edit/': typeof AuthenticatedCustomersGuidEditLayoutIndexRoute
  '/edit-insurance/$customer/cart/$cart/compositions': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute
  '/edit-insurance/$customer/cart/$cart/': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute
  '/add-insurance/$customer/cart/$cart/special': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute
  '/add-insurance/$customer/cart/$cart/summary': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteWithChildren
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute
  '/cart/new/$customer/ob': typeof AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute
  '/add-insurance/$customer/cart/$cart/product/$product': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteWithChildren
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/summary': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute
  '/add-insurance/$customer/cart/$cart/product/$product/compositions': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute
  '/add-insurance/$customer/cart/$cart/product/$product/': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/administration/company-details': typeof AuthenticatedAdministrationCompanyDetailsRoute
  '/administration/email-settings': typeof AuthenticatedAdministrationEmailSettingsRoute
  '/cart/customers': typeof AuthenticatedCartCustomersRoute
  '/tasks/$guid': typeof AuthenticatedTasksGuidRoute
  '/user/$guid': typeof AuthenticatedUserGuidRouteWithChildren
  '/add-insurance': typeof AuthenticatedAddInsuranceIndexRoute
  '/claims': typeof AuthenticatedClaimsIndexRoute
  '/contact': typeof AuthenticatedContactIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/inbox': typeof AuthenticatedInboxIndexRoute
  '/insurances': typeof AuthenticatedInsurancesIndexRoute
  '/quotations': typeof AuthenticatedQuotationsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/updates': typeof AuthenticatedUpdatesIndexRoute
  '/add-insurance/$customer': typeof AuthenticatedAddInsuranceCustomerLayoutIndexRoute
  '/add-insurance/$customer/insurance-send': typeof AuthenticatedAddInsuranceCustomerInsuranceSendRoute
  '/add-insurance/$customer/invoice-send': typeof AuthenticatedAddInsuranceCustomerInvoiceSendRoute
  '/add-insurance/$customer/special-send': typeof AuthenticatedAddInsuranceCustomerSpecialSendRoute
  '/claims/$guid': typeof AuthenticatedClaimsGuidLayoutIndexRoute
  '/claims/new': typeof AuthenticatedClaimsNewLayoutIndexRoute
  '/customers/$guid': typeof AuthenticatedCustomersGuidLayoutIndexRoute
  '/customers/new/$guid': typeof AuthenticatedCustomersNewGuidRoute
  '/insurances/$guid': typeof AuthenticatedInsurancesGuidLayoutIndexRoute
  '/quotations/$guid': typeof AuthenticatedQuotationsGuidLayoutIndexRoute
  '/tasks/new/claim': typeof AuthenticatedTasksNewClaimRoute
  '/tasks/new/customer': typeof AuthenticatedTasksNewCustomerRoute
  '/tasks/new/insurance': typeof AuthenticatedTasksNewInsuranceRoute
  '/tasks/new/quotation': typeof AuthenticatedTasksNewQuotationRoute
  '/user/$guid/edit': typeof AuthenticatedUserGuidEditRoute
  '/customers/new': typeof AuthenticatedCustomersNewIndexRoute
  '/tasks/new': typeof AuthenticatedTasksNewIndexRoute
  '/add-insurance/$customer/ob': typeof AuthenticatedAddInsuranceCustomerLayoutObRoute
  '/cart/new/$customer': typeof AuthenticatedCartNewCustomerLayoutRouteWithChildren
  '/claims/$guid/activities': typeof AuthenticatedClaimsGuidLayoutActivitiesRoute
  '/claims/$guid/details': typeof AuthenticatedClaimsGuidLayoutDetailsRoute
  '/claims/$guid/documents': typeof AuthenticatedClaimsGuidLayoutDocumentsRoute
  '/claims/$guid/notes': typeof AuthenticatedClaimsGuidLayoutNotesRoute
  '/claims/$guid/tasks': typeof AuthenticatedClaimsGuidLayoutTasksRoute
  '/customers/$guid/activities': typeof AuthenticatedCustomersGuidLayoutActivitiesRoute
  '/customers/$guid/claims': typeof AuthenticatedCustomersGuidLayoutClaimsRoute
  '/customers/$guid/insurances': typeof AuthenticatedCustomersGuidLayoutInsurancesRoute
  '/customers/$guid/invoices': typeof AuthenticatedCustomersGuidLayoutInvoicesRoute
  '/customers/$guid/notes': typeof AuthenticatedCustomersGuidLayoutNotesRoute
  '/customers/$guid/quotations': typeof AuthenticatedCustomersGuidLayoutQuotationsRoute
  '/customers/$guid/tasks': typeof AuthenticatedCustomersGuidLayoutTasksRoute
  '/customers/$guid/edit': typeof AuthenticatedCustomersGuidEditLayoutIndexRoute
  '/customers/$guid/edit/success': typeof AuthenticatedCustomersGuidEditSuccessRoute
  '/insurances/$guid/activities': typeof AuthenticatedInsurancesGuidLayoutActivitiesRoute
  '/insurances/$guid/claims': typeof AuthenticatedInsurancesGuidLayoutClaimsRoute
  '/insurances/$guid/documents': typeof AuthenticatedInsurancesGuidLayoutDocumentsRoute
  '/insurances/$guid/notes': typeof AuthenticatedInsurancesGuidLayoutNotesRoute
  '/insurances/$guid/tasks': typeof AuthenticatedInsurancesGuidLayoutTasksRoute
  '/quotations/$guid/activities': typeof AuthenticatedQuotationsGuidLayoutActivitiesRoute
  '/quotations/$guid/notes': typeof AuthenticatedQuotationsGuidLayoutNotesRoute
  '/quotations/$guid/premium-data': typeof AuthenticatedQuotationsGuidLayoutPremiumDataRoute
  '/quotations/$guid/tasks': typeof AuthenticatedQuotationsGuidLayoutTasksRoute
  '/cart/new/$customer/products': typeof AuthenticatedCartNewCustomerLayoutProductsRoute
  '/claims/new/$customer/$insurance': typeof AuthenticatedClaimsNewLayoutCustomerInsuranceRoute
  '/claims/new/$customer/external-system': typeof AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute
  '/claims/new/$customer/link-send': typeof AuthenticatedClaimsNewLayoutCustomerLinkSendRoute
  '/claims/new/$customer/success': typeof AuthenticatedClaimsNewLayoutCustomerSuccessRoute
  '/customers/$guid/edit/address': typeof AuthenticatedCustomersGuidEditLayoutAddressRoute
  '/customers/$guid/edit/contact': typeof AuthenticatedCustomersGuidEditLayoutContactRoute
  '/customers/$guid/edit/payment': typeof AuthenticatedCustomersGuidEditLayoutPaymentRoute
  '/customers/$guid/edit/personal-data': typeof AuthenticatedCustomersGuidEditLayoutPersonalDataRoute
  '/edit-insurance/$customer/cart/$cart': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute
  '/edit-insurance/$customer/cart/$cart/success': typeof AuthenticatedEditInsuranceCustomerCartCartSuccessRoute
  '/edit-insurance/$customer/cart/$cart/summary': typeof AuthenticatedEditInsuranceCustomerCartCartSummaryRoute
  '/claims/new/$customer': typeof AuthenticatedClaimsNewLayoutCustomerIndexRoute
  '/edit-insurance/$customer/cart/$cart/compositions': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute
  '/add-insurance/$customer/cart/$cart/special': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute
  '/add-insurance/$customer/cart/$cart/summary': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute
  '/cart/new/$customer/ob': typeof AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute
  '/add-insurance/$customer/cart/$cart/product/$product': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute
  '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/summary': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute
  '/add-insurance/$customer/cart/$cart/product/$product/compositions': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/callback': typeof CallbackRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/administration/company-details': typeof AuthenticatedAdministrationCompanyDetailsRoute
  '/_authenticated/administration/email-settings': typeof AuthenticatedAdministrationEmailSettingsRoute
  '/_authenticated/cart/customers': typeof AuthenticatedCartCustomersRoute
  '/_authenticated/tasks/$guid': typeof AuthenticatedTasksGuidRoute
  '/_authenticated/user/$guid': typeof AuthenticatedUserGuidRouteWithChildren
  '/_authenticated/add-insurance/': typeof AuthenticatedAddInsuranceIndexRoute
  '/_authenticated/claims/': typeof AuthenticatedClaimsIndexRoute
  '/_authenticated/contact/': typeof AuthenticatedContactIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/inbox/': typeof AuthenticatedInboxIndexRoute
  '/_authenticated/insurances/': typeof AuthenticatedInsurancesIndexRoute
  '/_authenticated/quotations/': typeof AuthenticatedQuotationsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/updates/': typeof AuthenticatedUpdatesIndexRoute
  '/_authenticated/add-insurance/$customer': typeof AuthenticatedAddInsuranceCustomerRouteWithChildren
  '/_authenticated/add-insurance/$customer/_layout': typeof AuthenticatedAddInsuranceCustomerLayoutRouteWithChildren
  '/_authenticated/add-insurance/$customer/insurance-send': typeof AuthenticatedAddInsuranceCustomerInsuranceSendRoute
  '/_authenticated/add-insurance/$customer/invoice-send': typeof AuthenticatedAddInsuranceCustomerInvoiceSendRoute
  '/_authenticated/add-insurance/$customer/special-send': typeof AuthenticatedAddInsuranceCustomerSpecialSendRoute
  '/_authenticated/claims/$guid': typeof AuthenticatedClaimsGuidRouteWithChildren
  '/_authenticated/claims/$guid/_layout': typeof AuthenticatedClaimsGuidLayoutRouteWithChildren
  '/_authenticated/claims/new': typeof AuthenticatedClaimsNewRouteWithChildren
  '/_authenticated/claims/new/_layout': typeof AuthenticatedClaimsNewLayoutRouteWithChildren
  '/_authenticated/customers/$guid': typeof AuthenticatedCustomersGuidRouteWithChildren
  '/_authenticated/customers/$guid/_layout': typeof AuthenticatedCustomersGuidLayoutRouteWithChildren
  '/_authenticated/customers/new/$guid': typeof AuthenticatedCustomersNewGuidRoute
  '/_authenticated/insurances/$guid': typeof AuthenticatedInsurancesGuidRouteWithChildren
  '/_authenticated/insurances/$guid/_layout': typeof AuthenticatedInsurancesGuidLayoutRouteWithChildren
  '/_authenticated/quotations/$guid': typeof AuthenticatedQuotationsGuidRouteWithChildren
  '/_authenticated/quotations/$guid/_layout': typeof AuthenticatedQuotationsGuidLayoutRouteWithChildren
  '/_authenticated/tasks/new/claim': typeof AuthenticatedTasksNewClaimRoute
  '/_authenticated/tasks/new/customer': typeof AuthenticatedTasksNewCustomerRoute
  '/_authenticated/tasks/new/insurance': typeof AuthenticatedTasksNewInsuranceRoute
  '/_authenticated/tasks/new/quotation': typeof AuthenticatedTasksNewQuotationRoute
  '/_authenticated/user/$guid/edit': typeof AuthenticatedUserGuidEditRoute
  '/_authenticated/customers/new/': typeof AuthenticatedCustomersNewIndexRoute
  '/_authenticated/tasks/new/': typeof AuthenticatedTasksNewIndexRoute
  '/_authenticated/add-insurance/$customer/_layout/ob': typeof AuthenticatedAddInsuranceCustomerLayoutObRoute
  '/_authenticated/cart/new/$customer': typeof AuthenticatedCartNewCustomerRouteWithChildren
  '/_authenticated/cart/new/$customer/_layout': typeof AuthenticatedCartNewCustomerLayoutRouteWithChildren
  '/_authenticated/claims/$guid/_layout/activities': typeof AuthenticatedClaimsGuidLayoutActivitiesRoute
  '/_authenticated/claims/$guid/_layout/details': typeof AuthenticatedClaimsGuidLayoutDetailsRoute
  '/_authenticated/claims/$guid/_layout/documents': typeof AuthenticatedClaimsGuidLayoutDocumentsRoute
  '/_authenticated/claims/$guid/_layout/notes': typeof AuthenticatedClaimsGuidLayoutNotesRoute
  '/_authenticated/claims/$guid/_layout/tasks': typeof AuthenticatedClaimsGuidLayoutTasksRoute
  '/_authenticated/customers/$guid/_layout/activities': typeof AuthenticatedCustomersGuidLayoutActivitiesRoute
  '/_authenticated/customers/$guid/_layout/claims': typeof AuthenticatedCustomersGuidLayoutClaimsRoute
  '/_authenticated/customers/$guid/_layout/insurances': typeof AuthenticatedCustomersGuidLayoutInsurancesRoute
  '/_authenticated/customers/$guid/_layout/invoices': typeof AuthenticatedCustomersGuidLayoutInvoicesRoute
  '/_authenticated/customers/$guid/_layout/notes': typeof AuthenticatedCustomersGuidLayoutNotesRoute
  '/_authenticated/customers/$guid/_layout/quotations': typeof AuthenticatedCustomersGuidLayoutQuotationsRoute
  '/_authenticated/customers/$guid/_layout/tasks': typeof AuthenticatedCustomersGuidLayoutTasksRoute
  '/_authenticated/customers/$guid/edit': typeof AuthenticatedCustomersGuidEditRouteWithChildren
  '/_authenticated/customers/$guid/edit/_layout': typeof AuthenticatedCustomersGuidEditLayoutRouteWithChildren
  '/_authenticated/customers/$guid/edit/success': typeof AuthenticatedCustomersGuidEditSuccessRoute
  '/_authenticated/insurances/$guid/_layout/activities': typeof AuthenticatedInsurancesGuidLayoutActivitiesRoute
  '/_authenticated/insurances/$guid/_layout/claims': typeof AuthenticatedInsurancesGuidLayoutClaimsRoute
  '/_authenticated/insurances/$guid/_layout/documents': typeof AuthenticatedInsurancesGuidLayoutDocumentsRoute
  '/_authenticated/insurances/$guid/_layout/notes': typeof AuthenticatedInsurancesGuidLayoutNotesRoute
  '/_authenticated/insurances/$guid/_layout/tasks': typeof AuthenticatedInsurancesGuidLayoutTasksRoute
  '/_authenticated/quotations/$guid/_layout/activities': typeof AuthenticatedQuotationsGuidLayoutActivitiesRoute
  '/_authenticated/quotations/$guid/_layout/notes': typeof AuthenticatedQuotationsGuidLayoutNotesRoute
  '/_authenticated/quotations/$guid/_layout/premium-data': typeof AuthenticatedQuotationsGuidLayoutPremiumDataRoute
  '/_authenticated/quotations/$guid/_layout/tasks': typeof AuthenticatedQuotationsGuidLayoutTasksRoute
  '/_authenticated/add-insurance/$customer/_layout/': typeof AuthenticatedAddInsuranceCustomerLayoutIndexRoute
  '/_authenticated/claims/$guid/_layout/': typeof AuthenticatedClaimsGuidLayoutIndexRoute
  '/_authenticated/claims/new/_layout/': typeof AuthenticatedClaimsNewLayoutIndexRoute
  '/_authenticated/customers/$guid/_layout/': typeof AuthenticatedCustomersGuidLayoutIndexRoute
  '/_authenticated/insurances/$guid/_layout/': typeof AuthenticatedInsurancesGuidLayoutIndexRoute
  '/_authenticated/quotations/$guid/_layout/': typeof AuthenticatedQuotationsGuidLayoutIndexRoute
  '/_authenticated/cart/new/$customer/_layout/products': typeof AuthenticatedCartNewCustomerLayoutProductsRoute
  '/_authenticated/claims/new/_layout/$customer/$insurance': typeof AuthenticatedClaimsNewLayoutCustomerInsuranceRoute
  '/_authenticated/claims/new/_layout/$customer/external-system': typeof AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute
  '/_authenticated/claims/new/_layout/$customer/link-send': typeof AuthenticatedClaimsNewLayoutCustomerLinkSendRoute
  '/_authenticated/claims/new/_layout/$customer/success': typeof AuthenticatedClaimsNewLayoutCustomerSuccessRoute
  '/_authenticated/customers/$guid/edit/_layout/address': typeof AuthenticatedCustomersGuidEditLayoutAddressRoute
  '/_authenticated/customers/$guid/edit/_layout/contact': typeof AuthenticatedCustomersGuidEditLayoutContactRoute
  '/_authenticated/customers/$guid/edit/_layout/payment': typeof AuthenticatedCustomersGuidEditLayoutPaymentRoute
  '/_authenticated/customers/$guid/edit/_layout/personal-data': typeof AuthenticatedCustomersGuidEditLayoutPersonalDataRoute
  '/_authenticated/edit-insurance/$customer/cart/$cart': typeof AuthenticatedEditInsuranceCustomerCartCartRouteWithChildren
  '/_authenticated/edit-insurance/$customer/cart/$cart/_layout': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutRouteWithChildren
  '/_authenticated/edit-insurance/$customer/cart/$cart/success': typeof AuthenticatedEditInsuranceCustomerCartCartSuccessRoute
  '/_authenticated/edit-insurance/$customer/cart/$cart/summary': typeof AuthenticatedEditInsuranceCustomerCartCartSummaryRoute
  '/_authenticated/claims/new/_layout/$customer/': typeof AuthenticatedClaimsNewLayoutCustomerIndexRoute
  '/_authenticated/customers/$guid/edit/_layout/': typeof AuthenticatedCustomersGuidEditLayoutIndexRoute
  '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/compositions': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute
  '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/': typeof AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/special': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/summary': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteWithChildren
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteWithChildren
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute
  '/_authenticated/cart/new/$customer/_layout/(object-code)/_layout/ob': typeof AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteWithChildren
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteWithChildren
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/summary': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/': typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/compositions': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/': typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/dashboard'
    | '/administration/company-details'
    | '/administration/email-settings'
    | '/cart/customers'
    | '/tasks/$guid'
    | '/user/$guid'
    | '/add-insurance'
    | '/claims'
    | '/contact'
    | '/customers'
    | '/inbox'
    | '/insurances'
    | '/quotations'
    | '/tasks'
    | '/updates'
    | '/add-insurance/$customer'
    | '/add-insurance/$customer/insurance-send'
    | '/add-insurance/$customer/invoice-send'
    | '/add-insurance/$customer/special-send'
    | '/claims/$guid'
    | '/claims/new'
    | '/customers/$guid'
    | '/customers/new/$guid'
    | '/insurances/$guid'
    | '/quotations/$guid'
    | '/tasks/new/claim'
    | '/tasks/new/customer'
    | '/tasks/new/insurance'
    | '/tasks/new/quotation'
    | '/user/$guid/edit'
    | '/customers/new'
    | '/tasks/new'
    | '/add-insurance/$customer/ob'
    | '/cart/new/$customer'
    | '/claims/$guid/activities'
    | '/claims/$guid/details'
    | '/claims/$guid/documents'
    | '/claims/$guid/notes'
    | '/claims/$guid/tasks'
    | '/customers/$guid/activities'
    | '/customers/$guid/claims'
    | '/customers/$guid/insurances'
    | '/customers/$guid/invoices'
    | '/customers/$guid/notes'
    | '/customers/$guid/quotations'
    | '/customers/$guid/tasks'
    | '/customers/$guid/edit'
    | '/customers/$guid/edit/success'
    | '/insurances/$guid/activities'
    | '/insurances/$guid/claims'
    | '/insurances/$guid/documents'
    | '/insurances/$guid/notes'
    | '/insurances/$guid/tasks'
    | '/quotations/$guid/activities'
    | '/quotations/$guid/notes'
    | '/quotations/$guid/premium-data'
    | '/quotations/$guid/tasks'
    | '/add-insurance/$customer/'
    | '/claims/$guid/'
    | '/claims/new/'
    | '/customers/$guid/'
    | '/insurances/$guid/'
    | '/quotations/$guid/'
    | '/cart/new/$customer/products'
    | '/claims/new/$customer/$insurance'
    | '/claims/new/$customer/external-system'
    | '/claims/new/$customer/link-send'
    | '/claims/new/$customer/success'
    | '/customers/$guid/edit/address'
    | '/customers/$guid/edit/contact'
    | '/customers/$guid/edit/payment'
    | '/customers/$guid/edit/personal-data'
    | '/edit-insurance/$customer/cart/$cart'
    | '/edit-insurance/$customer/cart/$cart/success'
    | '/edit-insurance/$customer/cart/$cart/summary'
    | '/claims/new/$customer'
    | '/customers/$guid/edit/'
    | '/edit-insurance/$customer/cart/$cart/compositions'
    | '/edit-insurance/$customer/cart/$cart/'
    | '/add-insurance/$customer/cart/$cart/special'
    | '/add-insurance/$customer/cart/$cart/summary'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success'
    | '/cart/new/$customer/ob'
    | '/add-insurance/$customer/cart/$cart/product/$product'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/summary'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/'
    | '/add-insurance/$customer/cart/$cart/product/$product/compositions'
    | '/add-insurance/$customer/cart/$cart/product/$product/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/dashboard'
    | '/administration/company-details'
    | '/administration/email-settings'
    | '/cart/customers'
    | '/tasks/$guid'
    | '/user/$guid'
    | '/add-insurance'
    | '/claims'
    | '/contact'
    | '/customers'
    | '/inbox'
    | '/insurances'
    | '/quotations'
    | '/tasks'
    | '/updates'
    | '/add-insurance/$customer'
    | '/add-insurance/$customer/insurance-send'
    | '/add-insurance/$customer/invoice-send'
    | '/add-insurance/$customer/special-send'
    | '/claims/$guid'
    | '/claims/new'
    | '/customers/$guid'
    | '/customers/new/$guid'
    | '/insurances/$guid'
    | '/quotations/$guid'
    | '/tasks/new/claim'
    | '/tasks/new/customer'
    | '/tasks/new/insurance'
    | '/tasks/new/quotation'
    | '/user/$guid/edit'
    | '/customers/new'
    | '/tasks/new'
    | '/add-insurance/$customer/ob'
    | '/cart/new/$customer'
    | '/claims/$guid/activities'
    | '/claims/$guid/details'
    | '/claims/$guid/documents'
    | '/claims/$guid/notes'
    | '/claims/$guid/tasks'
    | '/customers/$guid/activities'
    | '/customers/$guid/claims'
    | '/customers/$guid/insurances'
    | '/customers/$guid/invoices'
    | '/customers/$guid/notes'
    | '/customers/$guid/quotations'
    | '/customers/$guid/tasks'
    | '/customers/$guid/edit'
    | '/customers/$guid/edit/success'
    | '/insurances/$guid/activities'
    | '/insurances/$guid/claims'
    | '/insurances/$guid/documents'
    | '/insurances/$guid/notes'
    | '/insurances/$guid/tasks'
    | '/quotations/$guid/activities'
    | '/quotations/$guid/notes'
    | '/quotations/$guid/premium-data'
    | '/quotations/$guid/tasks'
    | '/cart/new/$customer/products'
    | '/claims/new/$customer/$insurance'
    | '/claims/new/$customer/external-system'
    | '/claims/new/$customer/link-send'
    | '/claims/new/$customer/success'
    | '/customers/$guid/edit/address'
    | '/customers/$guid/edit/contact'
    | '/customers/$guid/edit/payment'
    | '/customers/$guid/edit/personal-data'
    | '/edit-insurance/$customer/cart/$cart'
    | '/edit-insurance/$customer/cart/$cart/success'
    | '/edit-insurance/$customer/cart/$cart/summary'
    | '/claims/new/$customer'
    | '/edit-insurance/$customer/cart/$cart/compositions'
    | '/add-insurance/$customer/cart/$cart/special'
    | '/add-insurance/$customer/cart/$cart/summary'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success'
    | '/cart/new/$customer/ob'
    | '/add-insurance/$customer/cart/$cart/product/$product'
    | '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/summary'
    | '/add-insurance/$customer/cart/$cart/product/$product/compositions'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/callback'
    | '/_authenticated/dashboard'
    | '/_authenticated/administration/company-details'
    | '/_authenticated/administration/email-settings'
    | '/_authenticated/cart/customers'
    | '/_authenticated/tasks/$guid'
    | '/_authenticated/user/$guid'
    | '/_authenticated/add-insurance/'
    | '/_authenticated/claims/'
    | '/_authenticated/contact/'
    | '/_authenticated/customers/'
    | '/_authenticated/inbox/'
    | '/_authenticated/insurances/'
    | '/_authenticated/quotations/'
    | '/_authenticated/tasks/'
    | '/_authenticated/updates/'
    | '/_authenticated/add-insurance/$customer'
    | '/_authenticated/add-insurance/$customer/_layout'
    | '/_authenticated/add-insurance/$customer/insurance-send'
    | '/_authenticated/add-insurance/$customer/invoice-send'
    | '/_authenticated/add-insurance/$customer/special-send'
    | '/_authenticated/claims/$guid'
    | '/_authenticated/claims/$guid/_layout'
    | '/_authenticated/claims/new'
    | '/_authenticated/claims/new/_layout'
    | '/_authenticated/customers/$guid'
    | '/_authenticated/customers/$guid/_layout'
    | '/_authenticated/customers/new/$guid'
    | '/_authenticated/insurances/$guid'
    | '/_authenticated/insurances/$guid/_layout'
    | '/_authenticated/quotations/$guid'
    | '/_authenticated/quotations/$guid/_layout'
    | '/_authenticated/tasks/new/claim'
    | '/_authenticated/tasks/new/customer'
    | '/_authenticated/tasks/new/insurance'
    | '/_authenticated/tasks/new/quotation'
    | '/_authenticated/user/$guid/edit'
    | '/_authenticated/customers/new/'
    | '/_authenticated/tasks/new/'
    | '/_authenticated/add-insurance/$customer/_layout/ob'
    | '/_authenticated/cart/new/$customer'
    | '/_authenticated/cart/new/$customer/_layout'
    | '/_authenticated/claims/$guid/_layout/activities'
    | '/_authenticated/claims/$guid/_layout/details'
    | '/_authenticated/claims/$guid/_layout/documents'
    | '/_authenticated/claims/$guid/_layout/notes'
    | '/_authenticated/claims/$guid/_layout/tasks'
    | '/_authenticated/customers/$guid/_layout/activities'
    | '/_authenticated/customers/$guid/_layout/claims'
    | '/_authenticated/customers/$guid/_layout/insurances'
    | '/_authenticated/customers/$guid/_layout/invoices'
    | '/_authenticated/customers/$guid/_layout/notes'
    | '/_authenticated/customers/$guid/_layout/quotations'
    | '/_authenticated/customers/$guid/_layout/tasks'
    | '/_authenticated/customers/$guid/edit'
    | '/_authenticated/customers/$guid/edit/_layout'
    | '/_authenticated/customers/$guid/edit/success'
    | '/_authenticated/insurances/$guid/_layout/activities'
    | '/_authenticated/insurances/$guid/_layout/claims'
    | '/_authenticated/insurances/$guid/_layout/documents'
    | '/_authenticated/insurances/$guid/_layout/notes'
    | '/_authenticated/insurances/$guid/_layout/tasks'
    | '/_authenticated/quotations/$guid/_layout/activities'
    | '/_authenticated/quotations/$guid/_layout/notes'
    | '/_authenticated/quotations/$guid/_layout/premium-data'
    | '/_authenticated/quotations/$guid/_layout/tasks'
    | '/_authenticated/add-insurance/$customer/_layout/'
    | '/_authenticated/claims/$guid/_layout/'
    | '/_authenticated/claims/new/_layout/'
    | '/_authenticated/customers/$guid/_layout/'
    | '/_authenticated/insurances/$guid/_layout/'
    | '/_authenticated/quotations/$guid/_layout/'
    | '/_authenticated/cart/new/$customer/_layout/products'
    | '/_authenticated/claims/new/_layout/$customer/$insurance'
    | '/_authenticated/claims/new/_layout/$customer/external-system'
    | '/_authenticated/claims/new/_layout/$customer/link-send'
    | '/_authenticated/claims/new/_layout/$customer/success'
    | '/_authenticated/customers/$guid/edit/_layout/address'
    | '/_authenticated/customers/$guid/edit/_layout/contact'
    | '/_authenticated/customers/$guid/edit/_layout/payment'
    | '/_authenticated/customers/$guid/edit/_layout/personal-data'
    | '/_authenticated/edit-insurance/$customer/cart/$cart'
    | '/_authenticated/edit-insurance/$customer/cart/$cart/_layout'
    | '/_authenticated/edit-insurance/$customer/cart/$cart/success'
    | '/_authenticated/edit-insurance/$customer/cart/$cart/summary'
    | '/_authenticated/claims/new/_layout/$customer/'
    | '/_authenticated/customers/$guid/edit/_layout/'
    | '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/compositions'
    | '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/'
    | '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/special'
    | '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/summary'
    | '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
    | '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout'
    | '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success'
    | '/_authenticated/cart/new/$customer/_layout/(object-code)/_layout/ob'
    | '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product'
    | '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart'
    | '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/summary'
    | '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/'
    | '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/compositions'
    | '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CallbackRoute: typeof CallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations/$guid': {
      id: '/_authenticated/quotations/$guid'
      path: '/quotations/$guid'
      fullPath: '/quotations/$guid'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/insurances/$guid': {
      id: '/_authenticated/insurances/$guid'
      path: '/insurances/$guid'
      fullPath: '/insurances/$guid'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$guid': {
      id: '/_authenticated/customers/$guid'
      path: '/customers/$guid'
      fullPath: '/customers/$guid'
      preLoaderRoute: typeof AuthenticatedCustomersGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claims/new': {
      id: '/_authenticated/claims/new'
      path: '/claims/new'
      fullPath: '/claims/new'
      preLoaderRoute: typeof AuthenticatedClaimsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claims/$guid': {
      id: '/_authenticated/claims/$guid'
      path: '/claims/$guid'
      fullPath: '/claims/$guid'
      preLoaderRoute: typeof AuthenticatedClaimsGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/add-insurance/$customer': {
      id: '/_authenticated/add-insurance/$customer'
      path: '/add-insurance/$customer'
      fullPath: '/add-insurance/$customer'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/updates/': {
      id: '/_authenticated/updates/'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof AuthenticatedUpdatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations/': {
      id: '/_authenticated/quotations/'
      path: '/quotations'
      fullPath: '/quotations'
      preLoaderRoute: typeof AuthenticatedQuotationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/insurances/': {
      id: '/_authenticated/insurances/'
      path: '/insurances'
      fullPath: '/insurances'
      preLoaderRoute: typeof AuthenticatedInsurancesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbox/': {
      id: '/_authenticated/inbox/'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contact/': {
      id: '/_authenticated/contact/'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof AuthenticatedContactIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claims/': {
      id: '/_authenticated/claims/'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthenticatedClaimsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/add-insurance/': {
      id: '/_authenticated/add-insurance/'
      path: '/add-insurance'
      fullPath: '/add-insurance'
      preLoaderRoute: typeof AuthenticatedAddInsuranceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user/$guid': {
      id: '/_authenticated/user/$guid'
      path: '/user/$guid'
      fullPath: '/user/$guid'
      preLoaderRoute: typeof AuthenticatedUserGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$guid': {
      id: '/_authenticated/tasks/$guid'
      path: '/tasks/$guid'
      fullPath: '/tasks/$guid'
      preLoaderRoute: typeof AuthenticatedTasksGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cart/customers': {
      id: '/_authenticated/cart/customers'
      path: '/cart/customers'
      fullPath: '/cart/customers'
      preLoaderRoute: typeof AuthenticatedCartCustomersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/administration/email-settings': {
      id: '/_authenticated/administration/email-settings'
      path: '/administration/email-settings'
      fullPath: '/administration/email-settings'
      preLoaderRoute: typeof AuthenticatedAdministrationEmailSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/administration/company-details': {
      id: '/_authenticated/administration/company-details'
      path: '/administration/company-details'
      fullPath: '/administration/company-details'
      preLoaderRoute: typeof AuthenticatedAdministrationCompanyDetailsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$guid/edit': {
      id: '/_authenticated/customers/$guid/edit'
      path: '/edit'
      fullPath: '/customers/$guid/edit'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidRoute
    }
    '/_authenticated/cart/new/$customer': {
      id: '/_authenticated/cart/new/$customer'
      path: '/cart/new/$customer'
      fullPath: '/cart/new/$customer'
      preLoaderRoute: typeof AuthenticatedCartNewCustomerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new/': {
      id: '/_authenticated/tasks/new/'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof AuthenticatedTasksNewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/new/': {
      id: '/_authenticated/customers/new/'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AuthenticatedCustomersNewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user/$guid/edit': {
      id: '/_authenticated/user/$guid/edit'
      path: '/edit'
      fullPath: '/user/$guid/edit'
      preLoaderRoute: typeof AuthenticatedUserGuidEditRouteImport
      parentRoute: typeof AuthenticatedUserGuidRoute
    }
    '/_authenticated/tasks/new/quotation': {
      id: '/_authenticated/tasks/new/quotation'
      path: '/tasks/new/quotation'
      fullPath: '/tasks/new/quotation'
      preLoaderRoute: typeof AuthenticatedTasksNewQuotationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new/insurance': {
      id: '/_authenticated/tasks/new/insurance'
      path: '/tasks/new/insurance'
      fullPath: '/tasks/new/insurance'
      preLoaderRoute: typeof AuthenticatedTasksNewInsuranceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new/customer': {
      id: '/_authenticated/tasks/new/customer'
      path: '/tasks/new/customer'
      fullPath: '/tasks/new/customer'
      preLoaderRoute: typeof AuthenticatedTasksNewCustomerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new/claim': {
      id: '/_authenticated/tasks/new/claim'
      path: '/tasks/new/claim'
      fullPath: '/tasks/new/claim'
      preLoaderRoute: typeof AuthenticatedTasksNewClaimRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations/$guid/_layout': {
      id: '/_authenticated/quotations/$guid/_layout'
      path: '/quotations/$guid'
      fullPath: '/quotations/$guid'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidLayoutRouteImport
      parentRoute: typeof AuthenticatedQuotationsGuidRoute
    }
    '/_authenticated/insurances/$guid/_layout': {
      id: '/_authenticated/insurances/$guid/_layout'
      path: '/insurances/$guid'
      fullPath: '/insurances/$guid'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidRoute
    }
    '/_authenticated/customers/new/$guid': {
      id: '/_authenticated/customers/new/$guid'
      path: '/customers/new/$guid'
      fullPath: '/customers/new/$guid'
      preLoaderRoute: typeof AuthenticatedCustomersNewGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$guid/_layout': {
      id: '/_authenticated/customers/$guid/_layout'
      path: '/customers/$guid'
      fullPath: '/customers/$guid'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidRoute
    }
    '/_authenticated/claims/new/_layout': {
      id: '/_authenticated/claims/new/_layout'
      path: '/claims/new'
      fullPath: '/claims/new'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutRouteImport
      parentRoute: typeof AuthenticatedClaimsNewRoute
    }
    '/_authenticated/claims/$guid/_layout': {
      id: '/_authenticated/claims/$guid/_layout'
      path: '/claims/$guid'
      fullPath: '/claims/$guid'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidRoute
    }
    '/_authenticated/add-insurance/$customer/special-send': {
      id: '/_authenticated/add-insurance/$customer/special-send'
      path: '/special-send'
      fullPath: '/add-insurance/$customer/special-send'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerSpecialSendRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/add-insurance/$customer/invoice-send': {
      id: '/_authenticated/add-insurance/$customer/invoice-send'
      path: '/invoice-send'
      fullPath: '/add-insurance/$customer/invoice-send'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerInvoiceSendRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/add-insurance/$customer/insurance-send': {
      id: '/_authenticated/add-insurance/$customer/insurance-send'
      path: '/insurance-send'
      fullPath: '/add-insurance/$customer/insurance-send'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerInsuranceSendRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/add-insurance/$customer/_layout': {
      id: '/_authenticated/add-insurance/$customer/_layout'
      path: '/add-insurance/$customer'
      fullPath: '/add-insurance/$customer'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/edit-insurance/$customer/cart/$cart': {
      id: '/_authenticated/edit-insurance/$customer/cart/$cart'
      path: '/edit-insurance/$customer/cart/$cart'
      fullPath: '/edit-insurance/$customer/cart/$cart'
      preLoaderRoute: typeof AuthenticatedEditInsuranceCustomerCartCartRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quotations/$guid/_layout/': {
      id: '/_authenticated/quotations/$guid/_layout/'
      path: '/'
      fullPath: '/quotations/$guid/'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedQuotationsGuidLayoutRoute
    }
    '/_authenticated/insurances/$guid/_layout/': {
      id: '/_authenticated/insurances/$guid/_layout/'
      path: '/'
      fullPath: '/insurances/$guid/'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/': {
      id: '/_authenticated/customers/$guid/_layout/'
      path: '/'
      fullPath: '/customers/$guid/'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/claims/new/_layout/': {
      id: '/_authenticated/claims/new/_layout/'
      path: '/'
      fullPath: '/claims/new/'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedClaimsNewLayoutRoute
    }
    '/_authenticated/claims/$guid/_layout/': {
      id: '/_authenticated/claims/$guid/_layout/'
      path: '/'
      fullPath: '/claims/$guid/'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidLayoutRoute
    }
    '/_authenticated/add-insurance/$customer/_layout/': {
      id: '/_authenticated/add-insurance/$customer/_layout/'
      path: '/'
      fullPath: '/add-insurance/$customer/'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerLayoutRoute
    }
    '/_authenticated/quotations/$guid/_layout/tasks': {
      id: '/_authenticated/quotations/$guid/_layout/tasks'
      path: '/tasks'
      fullPath: '/quotations/$guid/tasks'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidLayoutTasksRouteImport
      parentRoute: typeof AuthenticatedQuotationsGuidLayoutRoute
    }
    '/_authenticated/quotations/$guid/_layout/premium-data': {
      id: '/_authenticated/quotations/$guid/_layout/premium-data'
      path: '/premium-data'
      fullPath: '/quotations/$guid/premium-data'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidLayoutPremiumDataRouteImport
      parentRoute: typeof AuthenticatedQuotationsGuidLayoutRoute
    }
    '/_authenticated/quotations/$guid/_layout/notes': {
      id: '/_authenticated/quotations/$guid/_layout/notes'
      path: '/notes'
      fullPath: '/quotations/$guid/notes'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidLayoutNotesRouteImport
      parentRoute: typeof AuthenticatedQuotationsGuidLayoutRoute
    }
    '/_authenticated/quotations/$guid/_layout/activities': {
      id: '/_authenticated/quotations/$guid/_layout/activities'
      path: '/activities'
      fullPath: '/quotations/$guid/activities'
      preLoaderRoute: typeof AuthenticatedQuotationsGuidLayoutActivitiesRouteImport
      parentRoute: typeof AuthenticatedQuotationsGuidLayoutRoute
    }
    '/_authenticated/insurances/$guid/_layout/tasks': {
      id: '/_authenticated/insurances/$guid/_layout/tasks'
      path: '/tasks'
      fullPath: '/insurances/$guid/tasks'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutTasksRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidLayoutRoute
    }
    '/_authenticated/insurances/$guid/_layout/notes': {
      id: '/_authenticated/insurances/$guid/_layout/notes'
      path: '/notes'
      fullPath: '/insurances/$guid/notes'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutNotesRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidLayoutRoute
    }
    '/_authenticated/insurances/$guid/_layout/documents': {
      id: '/_authenticated/insurances/$guid/_layout/documents'
      path: '/documents'
      fullPath: '/insurances/$guid/documents'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutDocumentsRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidLayoutRoute
    }
    '/_authenticated/insurances/$guid/_layout/claims': {
      id: '/_authenticated/insurances/$guid/_layout/claims'
      path: '/claims'
      fullPath: '/insurances/$guid/claims'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutClaimsRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidLayoutRoute
    }
    '/_authenticated/insurances/$guid/_layout/activities': {
      id: '/_authenticated/insurances/$guid/_layout/activities'
      path: '/activities'
      fullPath: '/insurances/$guid/activities'
      preLoaderRoute: typeof AuthenticatedInsurancesGuidLayoutActivitiesRouteImport
      parentRoute: typeof AuthenticatedInsurancesGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/edit/success': {
      id: '/_authenticated/customers/$guid/edit/success'
      path: '/success'
      fullPath: '/customers/$guid/edit/success'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditSuccessRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditRoute
    }
    '/_authenticated/customers/$guid/edit/_layout': {
      id: '/_authenticated/customers/$guid/edit/_layout'
      path: '/edit'
      fullPath: '/customers/$guid/edit'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditLayoutRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditRoute
    }
    '/_authenticated/customers/$guid/_layout/tasks': {
      id: '/_authenticated/customers/$guid/_layout/tasks'
      path: '/tasks'
      fullPath: '/customers/$guid/tasks'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutTasksRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/quotations': {
      id: '/_authenticated/customers/$guid/_layout/quotations'
      path: '/quotations'
      fullPath: '/customers/$guid/quotations'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutQuotationsRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/notes': {
      id: '/_authenticated/customers/$guid/_layout/notes'
      path: '/notes'
      fullPath: '/customers/$guid/notes'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutNotesRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/invoices': {
      id: '/_authenticated/customers/$guid/_layout/invoices'
      path: '/invoices'
      fullPath: '/customers/$guid/invoices'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutInvoicesRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/insurances': {
      id: '/_authenticated/customers/$guid/_layout/insurances'
      path: '/insurances'
      fullPath: '/customers/$guid/insurances'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutInsurancesRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/claims': {
      id: '/_authenticated/customers/$guid/_layout/claims'
      path: '/claims'
      fullPath: '/customers/$guid/claims'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutClaimsRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/customers/$guid/_layout/activities': {
      id: '/_authenticated/customers/$guid/_layout/activities'
      path: '/activities'
      fullPath: '/customers/$guid/activities'
      preLoaderRoute: typeof AuthenticatedCustomersGuidLayoutActivitiesRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidLayoutRoute
    }
    '/_authenticated/claims/$guid/_layout/tasks': {
      id: '/_authenticated/claims/$guid/_layout/tasks'
      path: '/tasks'
      fullPath: '/claims/$guid/tasks'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutTasksRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidLayoutRoute
    }
    '/_authenticated/claims/$guid/_layout/notes': {
      id: '/_authenticated/claims/$guid/_layout/notes'
      path: '/notes'
      fullPath: '/claims/$guid/notes'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutNotesRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidLayoutRoute
    }
    '/_authenticated/claims/$guid/_layout/documents': {
      id: '/_authenticated/claims/$guid/_layout/documents'
      path: '/documents'
      fullPath: '/claims/$guid/documents'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutDocumentsRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidLayoutRoute
    }
    '/_authenticated/claims/$guid/_layout/details': {
      id: '/_authenticated/claims/$guid/_layout/details'
      path: '/details'
      fullPath: '/claims/$guid/details'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutDetailsRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidLayoutRoute
    }
    '/_authenticated/claims/$guid/_layout/activities': {
      id: '/_authenticated/claims/$guid/_layout/activities'
      path: '/activities'
      fullPath: '/claims/$guid/activities'
      preLoaderRoute: typeof AuthenticatedClaimsGuidLayoutActivitiesRouteImport
      parentRoute: typeof AuthenticatedClaimsGuidLayoutRoute
    }
    '/_authenticated/cart/new/$customer/_layout': {
      id: '/_authenticated/cart/new/$customer/_layout'
      path: '/cart/new/$customer'
      fullPath: '/cart/new/$customer'
      preLoaderRoute: typeof AuthenticatedCartNewCustomerLayoutRouteImport
      parentRoute: typeof AuthenticatedCartNewCustomerRoute
    }
    '/_authenticated/add-insurance/$customer/_layout/ob': {
      id: '/_authenticated/add-insurance/$customer/_layout/ob'
      path: '/ob'
      fullPath: '/add-insurance/$customer/ob'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutObRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerLayoutRoute
    }
    '/_authenticated/customers/$guid/edit/_layout/': {
      id: '/_authenticated/customers/$guid/edit/_layout/'
      path: '/'
      fullPath: '/customers/$guid/edit/'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditLayoutRoute
    }
    '/_authenticated/claims/new/_layout/$customer/': {
      id: '/_authenticated/claims/new/_layout/$customer/'
      path: '/$customer'
      fullPath: '/claims/new/$customer'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutCustomerIndexRouteImport
      parentRoute: typeof AuthenticatedClaimsNewLayoutRoute
    }
    '/_authenticated/edit-insurance/$customer/cart/$cart/summary': {
      id: '/_authenticated/edit-insurance/$customer/cart/$cart/summary'
      path: '/summary'
      fullPath: '/edit-insurance/$customer/cart/$cart/summary'
      preLoaderRoute: typeof AuthenticatedEditInsuranceCustomerCartCartSummaryRouteImport
      parentRoute: typeof AuthenticatedEditInsuranceCustomerCartCartRoute
    }
    '/_authenticated/edit-insurance/$customer/cart/$cart/success': {
      id: '/_authenticated/edit-insurance/$customer/cart/$cart/success'
      path: '/success'
      fullPath: '/edit-insurance/$customer/cart/$cart/success'
      preLoaderRoute: typeof AuthenticatedEditInsuranceCustomerCartCartSuccessRouteImport
      parentRoute: typeof AuthenticatedEditInsuranceCustomerCartCartRoute
    }
    '/_authenticated/edit-insurance/$customer/cart/$cart/_layout': {
      id: '/_authenticated/edit-insurance/$customer/cart/$cart/_layout'
      path: '/edit-insurance/$customer/cart/$cart'
      fullPath: '/edit-insurance/$customer/cart/$cart'
      preLoaderRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutRouteImport
      parentRoute: typeof AuthenticatedEditInsuranceCustomerCartCartRoute
    }
    '/_authenticated/customers/$guid/edit/_layout/personal-data': {
      id: '/_authenticated/customers/$guid/edit/_layout/personal-data'
      path: '/personal-data'
      fullPath: '/customers/$guid/edit/personal-data'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditLayoutPersonalDataRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditLayoutRoute
    }
    '/_authenticated/customers/$guid/edit/_layout/payment': {
      id: '/_authenticated/customers/$guid/edit/_layout/payment'
      path: '/payment'
      fullPath: '/customers/$guid/edit/payment'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditLayoutPaymentRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditLayoutRoute
    }
    '/_authenticated/customers/$guid/edit/_layout/contact': {
      id: '/_authenticated/customers/$guid/edit/_layout/contact'
      path: '/contact'
      fullPath: '/customers/$guid/edit/contact'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditLayoutContactRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditLayoutRoute
    }
    '/_authenticated/customers/$guid/edit/_layout/address': {
      id: '/_authenticated/customers/$guid/edit/_layout/address'
      path: '/address'
      fullPath: '/customers/$guid/edit/address'
      preLoaderRoute: typeof AuthenticatedCustomersGuidEditLayoutAddressRouteImport
      parentRoute: typeof AuthenticatedCustomersGuidEditLayoutRoute
    }
    '/_authenticated/claims/new/_layout/$customer/success': {
      id: '/_authenticated/claims/new/_layout/$customer/success'
      path: '/$customer/success'
      fullPath: '/claims/new/$customer/success'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutCustomerSuccessRouteImport
      parentRoute: typeof AuthenticatedClaimsNewLayoutRoute
    }
    '/_authenticated/claims/new/_layout/$customer/link-send': {
      id: '/_authenticated/claims/new/_layout/$customer/link-send'
      path: '/$customer/link-send'
      fullPath: '/claims/new/$customer/link-send'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutCustomerLinkSendRouteImport
      parentRoute: typeof AuthenticatedClaimsNewLayoutRoute
    }
    '/_authenticated/claims/new/_layout/$customer/external-system': {
      id: '/_authenticated/claims/new/_layout/$customer/external-system'
      path: '/$customer/external-system'
      fullPath: '/claims/new/$customer/external-system'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutCustomerExternalSystemRouteImport
      parentRoute: typeof AuthenticatedClaimsNewLayoutRoute
    }
    '/_authenticated/claims/new/_layout/$customer/$insurance': {
      id: '/_authenticated/claims/new/_layout/$customer/$insurance'
      path: '/$customer/$insurance'
      fullPath: '/claims/new/$customer/$insurance'
      preLoaderRoute: typeof AuthenticatedClaimsNewLayoutCustomerInsuranceRouteImport
      parentRoute: typeof AuthenticatedClaimsNewLayoutRoute
    }
    '/_authenticated/cart/new/$customer/_layout/products': {
      id: '/_authenticated/cart/new/$customer/_layout/products'
      path: '/products'
      fullPath: '/cart/new/$customer/products'
      preLoaderRoute: typeof AuthenticatedCartNewCustomerLayoutProductsRouteImport
      parentRoute: typeof AuthenticatedCartNewCustomerLayoutRoute
    }
    '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance': {
      id: '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
      path: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
      fullPath: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
      preLoaderRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/': {
      id: '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/'
      path: '/'
      fullPath: '/edit-insurance/$customer/cart/$cart/'
      preLoaderRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutRoute
    }
    '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/compositions': {
      id: '/_authenticated/edit-insurance/$customer/cart/$cart/_layout/compositions'
      path: '/compositions'
      fullPath: '/edit-insurance/$customer/cart/$cart/compositions'
      preLoaderRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRouteImport
      parentRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutRoute
    }
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product': {
      id: '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product'
      path: '/cart/$cart/product/$product'
      fullPath: '/add-insurance/$customer/cart/$cart/product/$product'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/cart/new/$customer/_layout/(object-code)/_layout/ob': {
      id: '/_authenticated/cart/new/$customer/_layout/(object-code)/_layout/ob'
      path: '/ob'
      fullPath: '/cart/new/$customer/ob'
      preLoaderRoute: typeof AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRouteImport
      parentRoute: typeof AuthenticatedCartNewCustomerLayoutRoute
    }
    '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success': {
      id: '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success'
      path: '/success'
      fullPath: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success'
      preLoaderRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRouteImport
      parentRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute
    }
    '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout': {
      id: '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout'
      path: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
      fullPath: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance'
      preLoaderRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteImport
      parentRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute
    }
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/summary': {
      id: '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/summary'
      path: '/cart/$cart/summary'
      fullPath: '/add-insurance/$customer/cart/$cart/summary'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/special': {
      id: '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/special'
      path: '/cart/$cart/special'
      fullPath: '/add-insurance/$customer/cart/$cart/special'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerRoute
    }
    '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/': {
      id: '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/'
      path: '/'
      fullPath: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/'
      preLoaderRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute
    }
    '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/summary': {
      id: '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/summary'
      path: '/summary'
      fullPath: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/summary'
      preLoaderRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRouteImport
      parentRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute
    }
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart': {
      id: '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart'
      path: '/cart/$cart/product/$product'
      fullPath: '/add-insurance/$customer/cart/$cart/product/$product'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRoute
    }
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/': {
      id: '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/'
      path: '/'
      fullPath: '/add-insurance/$customer/cart/$cart/product/$product/'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute
    }
    '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/compositions': {
      id: '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/product/$product/_layout-cart/compositions'
      path: '/compositions'
      fullPath: '/add-insurance/$customer/cart/$cart/product/$product/compositions'
      preLoaderRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRouteImport
      parentRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute
    }
  }
}

interface AuthenticatedUserGuidRouteChildren {
  AuthenticatedUserGuidEditRoute: typeof AuthenticatedUserGuidEditRoute
}

const AuthenticatedUserGuidRouteChildren: AuthenticatedUserGuidRouteChildren = {
  AuthenticatedUserGuidEditRoute: AuthenticatedUserGuidEditRoute,
}

const AuthenticatedUserGuidRouteWithChildren =
  AuthenticatedUserGuidRoute._addFileChildren(
    AuthenticatedUserGuidRouteChildren,
  )

interface AuthenticatedAddInsuranceCustomerLayoutRouteChildren {
  AuthenticatedAddInsuranceCustomerLayoutObRoute: typeof AuthenticatedAddInsuranceCustomerLayoutObRoute
  AuthenticatedAddInsuranceCustomerLayoutIndexRoute: typeof AuthenticatedAddInsuranceCustomerLayoutIndexRoute
}

const AuthenticatedAddInsuranceCustomerLayoutRouteChildren: AuthenticatedAddInsuranceCustomerLayoutRouteChildren =
  {
    AuthenticatedAddInsuranceCustomerLayoutObRoute:
      AuthenticatedAddInsuranceCustomerLayoutObRoute,
    AuthenticatedAddInsuranceCustomerLayoutIndexRoute:
      AuthenticatedAddInsuranceCustomerLayoutIndexRoute,
  }

const AuthenticatedAddInsuranceCustomerLayoutRouteWithChildren =
  AuthenticatedAddInsuranceCustomerLayoutRoute._addFileChildren(
    AuthenticatedAddInsuranceCustomerLayoutRouteChildren,
  )

interface AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteChildren {
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute
}

const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteChildren: AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteChildren =
  {
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute:
      AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartCompositionsRoute,
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute:
      AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartIndexRoute,
  }

const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteWithChildren =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute._addFileChildren(
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteChildren,
  )

interface AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteChildren {
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteWithChildren
}

const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteChildren: AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteChildren =
  {
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRoute:
      AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductLayoutCartRouteWithChildren,
  }

const AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteWithChildren =
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRoute._addFileChildren(
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteChildren,
  )

interface AuthenticatedAddInsuranceCustomerRouteChildren {
  AuthenticatedAddInsuranceCustomerLayoutRoute: typeof AuthenticatedAddInsuranceCustomerLayoutRouteWithChildren
  AuthenticatedAddInsuranceCustomerInsuranceSendRoute: typeof AuthenticatedAddInsuranceCustomerInsuranceSendRoute
  AuthenticatedAddInsuranceCustomerInvoiceSendRoute: typeof AuthenticatedAddInsuranceCustomerInvoiceSendRoute
  AuthenticatedAddInsuranceCustomerSpecialSendRoute: typeof AuthenticatedAddInsuranceCustomerSpecialSendRoute
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute
  AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRoute: typeof AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteWithChildren
}

const AuthenticatedAddInsuranceCustomerRouteChildren: AuthenticatedAddInsuranceCustomerRouteChildren =
  {
    AuthenticatedAddInsuranceCustomerLayoutRoute:
      AuthenticatedAddInsuranceCustomerLayoutRouteWithChildren,
    AuthenticatedAddInsuranceCustomerInsuranceSendRoute:
      AuthenticatedAddInsuranceCustomerInsuranceSendRoute,
    AuthenticatedAddInsuranceCustomerInvoiceSendRoute:
      AuthenticatedAddInsuranceCustomerInvoiceSendRoute,
    AuthenticatedAddInsuranceCustomerSpecialSendRoute:
      AuthenticatedAddInsuranceCustomerSpecialSendRoute,
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute:
      AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSpecialRoute,
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute:
      AuthenticatedAddInsuranceCustomerLayoutCartCartCartLayoutCartSummaryRoute,
    AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRoute:
      AuthenticatedAddInsuranceCustomerLayoutCartCartCartProductProductRouteWithChildren,
  }

const AuthenticatedAddInsuranceCustomerRouteWithChildren =
  AuthenticatedAddInsuranceCustomerRoute._addFileChildren(
    AuthenticatedAddInsuranceCustomerRouteChildren,
  )

interface AuthenticatedClaimsGuidLayoutRouteChildren {
  AuthenticatedClaimsGuidLayoutActivitiesRoute: typeof AuthenticatedClaimsGuidLayoutActivitiesRoute
  AuthenticatedClaimsGuidLayoutDetailsRoute: typeof AuthenticatedClaimsGuidLayoutDetailsRoute
  AuthenticatedClaimsGuidLayoutDocumentsRoute: typeof AuthenticatedClaimsGuidLayoutDocumentsRoute
  AuthenticatedClaimsGuidLayoutNotesRoute: typeof AuthenticatedClaimsGuidLayoutNotesRoute
  AuthenticatedClaimsGuidLayoutTasksRoute: typeof AuthenticatedClaimsGuidLayoutTasksRoute
  AuthenticatedClaimsGuidLayoutIndexRoute: typeof AuthenticatedClaimsGuidLayoutIndexRoute
}

const AuthenticatedClaimsGuidLayoutRouteChildren: AuthenticatedClaimsGuidLayoutRouteChildren =
  {
    AuthenticatedClaimsGuidLayoutActivitiesRoute:
      AuthenticatedClaimsGuidLayoutActivitiesRoute,
    AuthenticatedClaimsGuidLayoutDetailsRoute:
      AuthenticatedClaimsGuidLayoutDetailsRoute,
    AuthenticatedClaimsGuidLayoutDocumentsRoute:
      AuthenticatedClaimsGuidLayoutDocumentsRoute,
    AuthenticatedClaimsGuidLayoutNotesRoute:
      AuthenticatedClaimsGuidLayoutNotesRoute,
    AuthenticatedClaimsGuidLayoutTasksRoute:
      AuthenticatedClaimsGuidLayoutTasksRoute,
    AuthenticatedClaimsGuidLayoutIndexRoute:
      AuthenticatedClaimsGuidLayoutIndexRoute,
  }

const AuthenticatedClaimsGuidLayoutRouteWithChildren =
  AuthenticatedClaimsGuidLayoutRoute._addFileChildren(
    AuthenticatedClaimsGuidLayoutRouteChildren,
  )

interface AuthenticatedClaimsGuidRouteChildren {
  AuthenticatedClaimsGuidLayoutRoute: typeof AuthenticatedClaimsGuidLayoutRouteWithChildren
}

const AuthenticatedClaimsGuidRouteChildren: AuthenticatedClaimsGuidRouteChildren =
  {
    AuthenticatedClaimsGuidLayoutRoute:
      AuthenticatedClaimsGuidLayoutRouteWithChildren,
  }

const AuthenticatedClaimsGuidRouteWithChildren =
  AuthenticatedClaimsGuidRoute._addFileChildren(
    AuthenticatedClaimsGuidRouteChildren,
  )

interface AuthenticatedClaimsNewLayoutRouteChildren {
  AuthenticatedClaimsNewLayoutIndexRoute: typeof AuthenticatedClaimsNewLayoutIndexRoute
  AuthenticatedClaimsNewLayoutCustomerInsuranceRoute: typeof AuthenticatedClaimsNewLayoutCustomerInsuranceRoute
  AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute: typeof AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute
  AuthenticatedClaimsNewLayoutCustomerLinkSendRoute: typeof AuthenticatedClaimsNewLayoutCustomerLinkSendRoute
  AuthenticatedClaimsNewLayoutCustomerSuccessRoute: typeof AuthenticatedClaimsNewLayoutCustomerSuccessRoute
  AuthenticatedClaimsNewLayoutCustomerIndexRoute: typeof AuthenticatedClaimsNewLayoutCustomerIndexRoute
}

const AuthenticatedClaimsNewLayoutRouteChildren: AuthenticatedClaimsNewLayoutRouteChildren =
  {
    AuthenticatedClaimsNewLayoutIndexRoute:
      AuthenticatedClaimsNewLayoutIndexRoute,
    AuthenticatedClaimsNewLayoutCustomerInsuranceRoute:
      AuthenticatedClaimsNewLayoutCustomerInsuranceRoute,
    AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute:
      AuthenticatedClaimsNewLayoutCustomerExternalSystemRoute,
    AuthenticatedClaimsNewLayoutCustomerLinkSendRoute:
      AuthenticatedClaimsNewLayoutCustomerLinkSendRoute,
    AuthenticatedClaimsNewLayoutCustomerSuccessRoute:
      AuthenticatedClaimsNewLayoutCustomerSuccessRoute,
    AuthenticatedClaimsNewLayoutCustomerIndexRoute:
      AuthenticatedClaimsNewLayoutCustomerIndexRoute,
  }

const AuthenticatedClaimsNewLayoutRouteWithChildren =
  AuthenticatedClaimsNewLayoutRoute._addFileChildren(
    AuthenticatedClaimsNewLayoutRouteChildren,
  )

interface AuthenticatedClaimsNewRouteChildren {
  AuthenticatedClaimsNewLayoutRoute: typeof AuthenticatedClaimsNewLayoutRouteWithChildren
}

const AuthenticatedClaimsNewRouteChildren: AuthenticatedClaimsNewRouteChildren =
  {
    AuthenticatedClaimsNewLayoutRoute:
      AuthenticatedClaimsNewLayoutRouteWithChildren,
  }

const AuthenticatedClaimsNewRouteWithChildren =
  AuthenticatedClaimsNewRoute._addFileChildren(
    AuthenticatedClaimsNewRouteChildren,
  )

interface AuthenticatedCustomersGuidLayoutRouteChildren {
  AuthenticatedCustomersGuidLayoutActivitiesRoute: typeof AuthenticatedCustomersGuidLayoutActivitiesRoute
  AuthenticatedCustomersGuidLayoutClaimsRoute: typeof AuthenticatedCustomersGuidLayoutClaimsRoute
  AuthenticatedCustomersGuidLayoutInsurancesRoute: typeof AuthenticatedCustomersGuidLayoutInsurancesRoute
  AuthenticatedCustomersGuidLayoutInvoicesRoute: typeof AuthenticatedCustomersGuidLayoutInvoicesRoute
  AuthenticatedCustomersGuidLayoutNotesRoute: typeof AuthenticatedCustomersGuidLayoutNotesRoute
  AuthenticatedCustomersGuidLayoutQuotationsRoute: typeof AuthenticatedCustomersGuidLayoutQuotationsRoute
  AuthenticatedCustomersGuidLayoutTasksRoute: typeof AuthenticatedCustomersGuidLayoutTasksRoute
  AuthenticatedCustomersGuidLayoutIndexRoute: typeof AuthenticatedCustomersGuidLayoutIndexRoute
}

const AuthenticatedCustomersGuidLayoutRouteChildren: AuthenticatedCustomersGuidLayoutRouteChildren =
  {
    AuthenticatedCustomersGuidLayoutActivitiesRoute:
      AuthenticatedCustomersGuidLayoutActivitiesRoute,
    AuthenticatedCustomersGuidLayoutClaimsRoute:
      AuthenticatedCustomersGuidLayoutClaimsRoute,
    AuthenticatedCustomersGuidLayoutInsurancesRoute:
      AuthenticatedCustomersGuidLayoutInsurancesRoute,
    AuthenticatedCustomersGuidLayoutInvoicesRoute:
      AuthenticatedCustomersGuidLayoutInvoicesRoute,
    AuthenticatedCustomersGuidLayoutNotesRoute:
      AuthenticatedCustomersGuidLayoutNotesRoute,
    AuthenticatedCustomersGuidLayoutQuotationsRoute:
      AuthenticatedCustomersGuidLayoutQuotationsRoute,
    AuthenticatedCustomersGuidLayoutTasksRoute:
      AuthenticatedCustomersGuidLayoutTasksRoute,
    AuthenticatedCustomersGuidLayoutIndexRoute:
      AuthenticatedCustomersGuidLayoutIndexRoute,
  }

const AuthenticatedCustomersGuidLayoutRouteWithChildren =
  AuthenticatedCustomersGuidLayoutRoute._addFileChildren(
    AuthenticatedCustomersGuidLayoutRouteChildren,
  )

interface AuthenticatedCustomersGuidEditLayoutRouteChildren {
  AuthenticatedCustomersGuidEditLayoutAddressRoute: typeof AuthenticatedCustomersGuidEditLayoutAddressRoute
  AuthenticatedCustomersGuidEditLayoutContactRoute: typeof AuthenticatedCustomersGuidEditLayoutContactRoute
  AuthenticatedCustomersGuidEditLayoutPaymentRoute: typeof AuthenticatedCustomersGuidEditLayoutPaymentRoute
  AuthenticatedCustomersGuidEditLayoutPersonalDataRoute: typeof AuthenticatedCustomersGuidEditLayoutPersonalDataRoute
  AuthenticatedCustomersGuidEditLayoutIndexRoute: typeof AuthenticatedCustomersGuidEditLayoutIndexRoute
}

const AuthenticatedCustomersGuidEditLayoutRouteChildren: AuthenticatedCustomersGuidEditLayoutRouteChildren =
  {
    AuthenticatedCustomersGuidEditLayoutAddressRoute:
      AuthenticatedCustomersGuidEditLayoutAddressRoute,
    AuthenticatedCustomersGuidEditLayoutContactRoute:
      AuthenticatedCustomersGuidEditLayoutContactRoute,
    AuthenticatedCustomersGuidEditLayoutPaymentRoute:
      AuthenticatedCustomersGuidEditLayoutPaymentRoute,
    AuthenticatedCustomersGuidEditLayoutPersonalDataRoute:
      AuthenticatedCustomersGuidEditLayoutPersonalDataRoute,
    AuthenticatedCustomersGuidEditLayoutIndexRoute:
      AuthenticatedCustomersGuidEditLayoutIndexRoute,
  }

const AuthenticatedCustomersGuidEditLayoutRouteWithChildren =
  AuthenticatedCustomersGuidEditLayoutRoute._addFileChildren(
    AuthenticatedCustomersGuidEditLayoutRouteChildren,
  )

interface AuthenticatedCustomersGuidEditRouteChildren {
  AuthenticatedCustomersGuidEditLayoutRoute: typeof AuthenticatedCustomersGuidEditLayoutRouteWithChildren
  AuthenticatedCustomersGuidEditSuccessRoute: typeof AuthenticatedCustomersGuidEditSuccessRoute
}

const AuthenticatedCustomersGuidEditRouteChildren: AuthenticatedCustomersGuidEditRouteChildren =
  {
    AuthenticatedCustomersGuidEditLayoutRoute:
      AuthenticatedCustomersGuidEditLayoutRouteWithChildren,
    AuthenticatedCustomersGuidEditSuccessRoute:
      AuthenticatedCustomersGuidEditSuccessRoute,
  }

const AuthenticatedCustomersGuidEditRouteWithChildren =
  AuthenticatedCustomersGuidEditRoute._addFileChildren(
    AuthenticatedCustomersGuidEditRouteChildren,
  )

interface AuthenticatedCustomersGuidRouteChildren {
  AuthenticatedCustomersGuidLayoutRoute: typeof AuthenticatedCustomersGuidLayoutRouteWithChildren
  AuthenticatedCustomersGuidEditRoute: typeof AuthenticatedCustomersGuidEditRouteWithChildren
}

const AuthenticatedCustomersGuidRouteChildren: AuthenticatedCustomersGuidRouteChildren =
  {
    AuthenticatedCustomersGuidLayoutRoute:
      AuthenticatedCustomersGuidLayoutRouteWithChildren,
    AuthenticatedCustomersGuidEditRoute:
      AuthenticatedCustomersGuidEditRouteWithChildren,
  }

const AuthenticatedCustomersGuidRouteWithChildren =
  AuthenticatedCustomersGuidRoute._addFileChildren(
    AuthenticatedCustomersGuidRouteChildren,
  )

interface AuthenticatedInsurancesGuidLayoutRouteChildren {
  AuthenticatedInsurancesGuidLayoutActivitiesRoute: typeof AuthenticatedInsurancesGuidLayoutActivitiesRoute
  AuthenticatedInsurancesGuidLayoutClaimsRoute: typeof AuthenticatedInsurancesGuidLayoutClaimsRoute
  AuthenticatedInsurancesGuidLayoutDocumentsRoute: typeof AuthenticatedInsurancesGuidLayoutDocumentsRoute
  AuthenticatedInsurancesGuidLayoutNotesRoute: typeof AuthenticatedInsurancesGuidLayoutNotesRoute
  AuthenticatedInsurancesGuidLayoutTasksRoute: typeof AuthenticatedInsurancesGuidLayoutTasksRoute
  AuthenticatedInsurancesGuidLayoutIndexRoute: typeof AuthenticatedInsurancesGuidLayoutIndexRoute
}

const AuthenticatedInsurancesGuidLayoutRouteChildren: AuthenticatedInsurancesGuidLayoutRouteChildren =
  {
    AuthenticatedInsurancesGuidLayoutActivitiesRoute:
      AuthenticatedInsurancesGuidLayoutActivitiesRoute,
    AuthenticatedInsurancesGuidLayoutClaimsRoute:
      AuthenticatedInsurancesGuidLayoutClaimsRoute,
    AuthenticatedInsurancesGuidLayoutDocumentsRoute:
      AuthenticatedInsurancesGuidLayoutDocumentsRoute,
    AuthenticatedInsurancesGuidLayoutNotesRoute:
      AuthenticatedInsurancesGuidLayoutNotesRoute,
    AuthenticatedInsurancesGuidLayoutTasksRoute:
      AuthenticatedInsurancesGuidLayoutTasksRoute,
    AuthenticatedInsurancesGuidLayoutIndexRoute:
      AuthenticatedInsurancesGuidLayoutIndexRoute,
  }

const AuthenticatedInsurancesGuidLayoutRouteWithChildren =
  AuthenticatedInsurancesGuidLayoutRoute._addFileChildren(
    AuthenticatedInsurancesGuidLayoutRouteChildren,
  )

interface AuthenticatedInsurancesGuidRouteChildren {
  AuthenticatedInsurancesGuidLayoutRoute: typeof AuthenticatedInsurancesGuidLayoutRouteWithChildren
}

const AuthenticatedInsurancesGuidRouteChildren: AuthenticatedInsurancesGuidRouteChildren =
  {
    AuthenticatedInsurancesGuidLayoutRoute:
      AuthenticatedInsurancesGuidLayoutRouteWithChildren,
  }

const AuthenticatedInsurancesGuidRouteWithChildren =
  AuthenticatedInsurancesGuidRoute._addFileChildren(
    AuthenticatedInsurancesGuidRouteChildren,
  )

interface AuthenticatedQuotationsGuidLayoutRouteChildren {
  AuthenticatedQuotationsGuidLayoutActivitiesRoute: typeof AuthenticatedQuotationsGuidLayoutActivitiesRoute
  AuthenticatedQuotationsGuidLayoutNotesRoute: typeof AuthenticatedQuotationsGuidLayoutNotesRoute
  AuthenticatedQuotationsGuidLayoutPremiumDataRoute: typeof AuthenticatedQuotationsGuidLayoutPremiumDataRoute
  AuthenticatedQuotationsGuidLayoutTasksRoute: typeof AuthenticatedQuotationsGuidLayoutTasksRoute
  AuthenticatedQuotationsGuidLayoutIndexRoute: typeof AuthenticatedQuotationsGuidLayoutIndexRoute
}

const AuthenticatedQuotationsGuidLayoutRouteChildren: AuthenticatedQuotationsGuidLayoutRouteChildren =
  {
    AuthenticatedQuotationsGuidLayoutActivitiesRoute:
      AuthenticatedQuotationsGuidLayoutActivitiesRoute,
    AuthenticatedQuotationsGuidLayoutNotesRoute:
      AuthenticatedQuotationsGuidLayoutNotesRoute,
    AuthenticatedQuotationsGuidLayoutPremiumDataRoute:
      AuthenticatedQuotationsGuidLayoutPremiumDataRoute,
    AuthenticatedQuotationsGuidLayoutTasksRoute:
      AuthenticatedQuotationsGuidLayoutTasksRoute,
    AuthenticatedQuotationsGuidLayoutIndexRoute:
      AuthenticatedQuotationsGuidLayoutIndexRoute,
  }

const AuthenticatedQuotationsGuidLayoutRouteWithChildren =
  AuthenticatedQuotationsGuidLayoutRoute._addFileChildren(
    AuthenticatedQuotationsGuidLayoutRouteChildren,
  )

interface AuthenticatedQuotationsGuidRouteChildren {
  AuthenticatedQuotationsGuidLayoutRoute: typeof AuthenticatedQuotationsGuidLayoutRouteWithChildren
}

const AuthenticatedQuotationsGuidRouteChildren: AuthenticatedQuotationsGuidRouteChildren =
  {
    AuthenticatedQuotationsGuidLayoutRoute:
      AuthenticatedQuotationsGuidLayoutRouteWithChildren,
  }

const AuthenticatedQuotationsGuidRouteWithChildren =
  AuthenticatedQuotationsGuidRoute._addFileChildren(
    AuthenticatedQuotationsGuidRouteChildren,
  )

interface AuthenticatedCartNewCustomerLayoutRouteChildren {
  AuthenticatedCartNewCustomerLayoutProductsRoute: typeof AuthenticatedCartNewCustomerLayoutProductsRoute
  AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute: typeof AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute
}

const AuthenticatedCartNewCustomerLayoutRouteChildren: AuthenticatedCartNewCustomerLayoutRouteChildren =
  {
    AuthenticatedCartNewCustomerLayoutProductsRoute:
      AuthenticatedCartNewCustomerLayoutProductsRoute,
    AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute:
      AuthenticatedCartNewCustomerLayoutobjectCodeLayoutObRoute,
  }

const AuthenticatedCartNewCustomerLayoutRouteWithChildren =
  AuthenticatedCartNewCustomerLayoutRoute._addFileChildren(
    AuthenticatedCartNewCustomerLayoutRouteChildren,
  )

interface AuthenticatedCartNewCustomerRouteChildren {
  AuthenticatedCartNewCustomerLayoutRoute: typeof AuthenticatedCartNewCustomerLayoutRouteWithChildren
}

const AuthenticatedCartNewCustomerRouteChildren: AuthenticatedCartNewCustomerRouteChildren =
  {
    AuthenticatedCartNewCustomerLayoutRoute:
      AuthenticatedCartNewCustomerLayoutRouteWithChildren,
  }

const AuthenticatedCartNewCustomerRouteWithChildren =
  AuthenticatedCartNewCustomerRoute._addFileChildren(
    AuthenticatedCartNewCustomerRouteChildren,
  )

interface AuthenticatedEditInsuranceCustomerCartCartLayoutRouteChildren {
  AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute
  AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute
}

const AuthenticatedEditInsuranceCustomerCartCartLayoutRouteChildren: AuthenticatedEditInsuranceCustomerCartCartLayoutRouteChildren =
  {
    AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute:
      AuthenticatedEditInsuranceCustomerCartCartLayoutCompositionsRoute,
    AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute:
      AuthenticatedEditInsuranceCustomerCartCartLayoutIndexRoute,
  }

const AuthenticatedEditInsuranceCustomerCartCartLayoutRouteWithChildren =
  AuthenticatedEditInsuranceCustomerCartCartLayoutRoute._addFileChildren(
    AuthenticatedEditInsuranceCustomerCartCartLayoutRouteChildren,
  )

interface AuthenticatedEditInsuranceCustomerCartCartRouteChildren {
  AuthenticatedEditInsuranceCustomerCartCartLayoutRoute: typeof AuthenticatedEditInsuranceCustomerCartCartLayoutRouteWithChildren
  AuthenticatedEditInsuranceCustomerCartCartSuccessRoute: typeof AuthenticatedEditInsuranceCustomerCartCartSuccessRoute
  AuthenticatedEditInsuranceCustomerCartCartSummaryRoute: typeof AuthenticatedEditInsuranceCustomerCartCartSummaryRoute
}

const AuthenticatedEditInsuranceCustomerCartCartRouteChildren: AuthenticatedEditInsuranceCustomerCartCartRouteChildren =
  {
    AuthenticatedEditInsuranceCustomerCartCartLayoutRoute:
      AuthenticatedEditInsuranceCustomerCartCartLayoutRouteWithChildren,
    AuthenticatedEditInsuranceCustomerCartCartSuccessRoute:
      AuthenticatedEditInsuranceCustomerCartCartSuccessRoute,
    AuthenticatedEditInsuranceCustomerCartCartSummaryRoute:
      AuthenticatedEditInsuranceCustomerCartCartSummaryRoute,
  }

const AuthenticatedEditInsuranceCustomerCartCartRouteWithChildren =
  AuthenticatedEditInsuranceCustomerCartCartRoute._addFileChildren(
    AuthenticatedEditInsuranceCustomerCartCartRouteChildren,
  )

interface AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteChildren {
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute
}

const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteChildren: AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteChildren =
  {
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute:
      AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutSummaryRoute,
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute:
      AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutIndexRoute,
  }

const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteWithChildren =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute._addFileChildren(
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteChildren,
  )

interface AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteChildren {
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteWithChildren
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute
}

const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteChildren: AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteChildren =
  {
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRoute:
      AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceLayoutRouteWithChildren,
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute:
      AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceSuccessRoute,
  }

const AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteWithChildren =
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute._addFileChildren(
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedAdministrationCompanyDetailsRoute: typeof AuthenticatedAdministrationCompanyDetailsRoute
  AuthenticatedAdministrationEmailSettingsRoute: typeof AuthenticatedAdministrationEmailSettingsRoute
  AuthenticatedCartCustomersRoute: typeof AuthenticatedCartCustomersRoute
  AuthenticatedTasksGuidRoute: typeof AuthenticatedTasksGuidRoute
  AuthenticatedUserGuidRoute: typeof AuthenticatedUserGuidRouteWithChildren
  AuthenticatedAddInsuranceIndexRoute: typeof AuthenticatedAddInsuranceIndexRoute
  AuthenticatedClaimsIndexRoute: typeof AuthenticatedClaimsIndexRoute
  AuthenticatedContactIndexRoute: typeof AuthenticatedContactIndexRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedInboxIndexRoute: typeof AuthenticatedInboxIndexRoute
  AuthenticatedInsurancesIndexRoute: typeof AuthenticatedInsurancesIndexRoute
  AuthenticatedQuotationsIndexRoute: typeof AuthenticatedQuotationsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedUpdatesIndexRoute: typeof AuthenticatedUpdatesIndexRoute
  AuthenticatedAddInsuranceCustomerRoute: typeof AuthenticatedAddInsuranceCustomerRouteWithChildren
  AuthenticatedClaimsGuidRoute: typeof AuthenticatedClaimsGuidRouteWithChildren
  AuthenticatedClaimsNewRoute: typeof AuthenticatedClaimsNewRouteWithChildren
  AuthenticatedCustomersGuidRoute: typeof AuthenticatedCustomersGuidRouteWithChildren
  AuthenticatedCustomersNewGuidRoute: typeof AuthenticatedCustomersNewGuidRoute
  AuthenticatedInsurancesGuidRoute: typeof AuthenticatedInsurancesGuidRouteWithChildren
  AuthenticatedQuotationsGuidRoute: typeof AuthenticatedQuotationsGuidRouteWithChildren
  AuthenticatedTasksNewClaimRoute: typeof AuthenticatedTasksNewClaimRoute
  AuthenticatedTasksNewCustomerRoute: typeof AuthenticatedTasksNewCustomerRoute
  AuthenticatedTasksNewInsuranceRoute: typeof AuthenticatedTasksNewInsuranceRoute
  AuthenticatedTasksNewQuotationRoute: typeof AuthenticatedTasksNewQuotationRoute
  AuthenticatedCustomersNewIndexRoute: typeof AuthenticatedCustomersNewIndexRoute
  AuthenticatedTasksNewIndexRoute: typeof AuthenticatedTasksNewIndexRoute
  AuthenticatedCartNewCustomerRoute: typeof AuthenticatedCartNewCustomerRouteWithChildren
  AuthenticatedEditInsuranceCustomerCartCartRoute: typeof AuthenticatedEditInsuranceCustomerCartCartRouteWithChildren
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute: typeof AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedAdministrationCompanyDetailsRoute:
    AuthenticatedAdministrationCompanyDetailsRoute,
  AuthenticatedAdministrationEmailSettingsRoute:
    AuthenticatedAdministrationEmailSettingsRoute,
  AuthenticatedCartCustomersRoute: AuthenticatedCartCustomersRoute,
  AuthenticatedTasksGuidRoute: AuthenticatedTasksGuidRoute,
  AuthenticatedUserGuidRoute: AuthenticatedUserGuidRouteWithChildren,
  AuthenticatedAddInsuranceIndexRoute: AuthenticatedAddInsuranceIndexRoute,
  AuthenticatedClaimsIndexRoute: AuthenticatedClaimsIndexRoute,
  AuthenticatedContactIndexRoute: AuthenticatedContactIndexRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedInboxIndexRoute: AuthenticatedInboxIndexRoute,
  AuthenticatedInsurancesIndexRoute: AuthenticatedInsurancesIndexRoute,
  AuthenticatedQuotationsIndexRoute: AuthenticatedQuotationsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedUpdatesIndexRoute: AuthenticatedUpdatesIndexRoute,
  AuthenticatedAddInsuranceCustomerRoute:
    AuthenticatedAddInsuranceCustomerRouteWithChildren,
  AuthenticatedClaimsGuidRoute: AuthenticatedClaimsGuidRouteWithChildren,
  AuthenticatedClaimsNewRoute: AuthenticatedClaimsNewRouteWithChildren,
  AuthenticatedCustomersGuidRoute: AuthenticatedCustomersGuidRouteWithChildren,
  AuthenticatedCustomersNewGuidRoute: AuthenticatedCustomersNewGuidRoute,
  AuthenticatedInsurancesGuidRoute:
    AuthenticatedInsurancesGuidRouteWithChildren,
  AuthenticatedQuotationsGuidRoute:
    AuthenticatedQuotationsGuidRouteWithChildren,
  AuthenticatedTasksNewClaimRoute: AuthenticatedTasksNewClaimRoute,
  AuthenticatedTasksNewCustomerRoute: AuthenticatedTasksNewCustomerRoute,
  AuthenticatedTasksNewInsuranceRoute: AuthenticatedTasksNewInsuranceRoute,
  AuthenticatedTasksNewQuotationRoute: AuthenticatedTasksNewQuotationRoute,
  AuthenticatedCustomersNewIndexRoute: AuthenticatedCustomersNewIndexRoute,
  AuthenticatedTasksNewIndexRoute: AuthenticatedTasksNewIndexRoute,
  AuthenticatedCartNewCustomerRoute:
    AuthenticatedCartNewCustomerRouteWithChildren,
  AuthenticatedEditInsuranceCustomerCartCartRoute:
    AuthenticatedEditInsuranceCustomerCartCartRouteWithChildren,
  AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRoute:
    AuthenticatedCancelInsuranceCustomerCartCartInsuranceInsuranceRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CallbackRoute: CallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
